export function isFileType(_arg) {
    return _arg === "svg" ||
        _arg === "dxf" ||
        _arg === "step" ||
        _arg === "png" ||
        _arg === "geo";
}
export function isInputType(_arg) {
    return _arg === "undefined" ||
        _arg === "documentGraph" ||
        _arg === "assembly" ||
        _arg === "layered" ||
        _arg === "twoDimRep";
}
export function isDatabaseType(_arg) {
    return _arg === "mssql";
}
export function isFileSystemPathType(_arg) {
    return _arg === "directory" ||
        _arg === "openFile" ||
        _arg === "saveFile";
}
export function isWorkStepType(_arg) {
    return _arg === "undefined" ||
        _arg === "sheet" ||
        _arg === "sheetCutting" ||
        _arg === "joining" ||
        _arg === "tubeCutting" ||
        _arg === "sheetBending" ||
        _arg === "userDefined" ||
        _arg === "userDefinedBase" ||
        _arg === "packaging" ||
        _arg === "transform" ||
        _arg === "tube";
}
export function isBendDieChoiceType(_arg) {
    return _arg === "database" ||
        _arg === "neutralAxis";
}
export function isDocumentItemType(_arg) {
    return _arg === "paragraph" ||
        _arg === "heading" ||
        _arg === "table" ||
        _arg === "image" ||
        _arg === "barcode" ||
        _arg === "separator" ||
        _arg === "pageBreak";
}
export function isDocumentAlignment(_arg) {
    return _arg === "left" ||
        _arg === "center" ||
        _arg === "right";
}
export function isDocumentImageType(_arg) {
    return _arg === "png" ||
        _arg === "svg";
}
export function isDocumentOrientation(_arg) {
    return _arg === "portrait" ||
        _arg === "landscape";
}
export function isGraphNodeProcessingState(_arg) {
    return _arg === "CreateWorkStep" ||
        _arg === "UpdateWorkStep" ||
        _arg === "CreateSources" ||
        _arg === "FillFromSources" ||
        _arg === "AfterFillFromSources" ||
        _arg === "Finished";
}
export function isProcessType(_arg) {
    return _arg === "undefined" ||
        _arg === "manufacturing" ||
        _arg === "semiManufactured" ||
        _arg === "sheetCutting" ||
        _arg === "laserSheetCutting" ||
        _arg === "joining" ||
        _arg === "externalPart" ||
        _arg === "sheet" ||
        _arg === "userDefinedBaseType" ||
        _arg === "assembling" ||
        _arg === "forceFitting" ||
        _arg === "joiningByWelding" ||
        _arg === "joiningByBrazing" ||
        _arg === "bonding" ||
        _arg === "autogenousWelding" ||
        _arg === "arcWelding" ||
        _arg === "gasShieldedWelding" ||
        _arg === "migWelding" ||
        _arg === "magWelding" ||
        _arg === "tigWelding" ||
        _arg === "plasmaWelding" ||
        _arg === "laserWelding" ||
        _arg === "weldingWithPressure" ||
        _arg === "resistanceWelding" ||
        _arg === "studWelding" ||
        _arg === "forming" ||
        _arg === "bendForming" ||
        _arg === "bendingWithoutTool" ||
        _arg === "dieBending" ||
        _arg === "sheetMetalFolding" ||
        _arg === "cutting" ||
        _arg === "removalOperation" ||
        _arg === "plasmaSheetCutting" ||
        _arg === "waterJetSheetCutting" ||
        _arg === "machining" ||
        _arg === "milling" ||
        _arg === "turning" ||
        _arg === "drilling" ||
        _arg === "threading" ||
        _arg === "mechanicalDeburring" ||
        _arg === "cleaning" ||
        _arg === "coating" ||
        _arg === "sprayPainting" ||
        _arg === "powderCoating" ||
        _arg === "sheetBending" ||
        _arg === "transport" ||
        _arg === "packaging" ||
        _arg === "automaticMechanicalDeburring" ||
        _arg === "manualMechanicalDeburring" ||
        _arg === "userDefinedMachining" ||
        _arg === "userDefinedThreading" ||
        _arg === "userDefinedCountersinking" ||
        _arg === "slideGrinding" ||
        _arg === "sheetTapping" ||
        _arg === "userDefinedTube" ||
        _arg === "tube" ||
        _arg === "tubeCutting";
}
export function isTubeProfileGeometryType(_arg) {
    return _arg === "rectangular" ||
        _arg === "circular";
}
export function isTableType(_arg) {
    return _arg === "sheetMaterial" ||
        _arg === "sheetMaterialDensity" ||
        _arg === "sheetCuttingMaterialMapping" ||
        _arg === "sheetBendingMaterialMapping" ||
        _arg === "bendTime" ||
        _arg === "bendTimeParameters" ||
        _arg === "bendRateParameters" ||
        _arg === "bendLineConstraint" ||
        _arg === "laserSheetCuttingGas" ||
        _arg === "laserSheetCuttingSpeed" ||
        _arg === "laserSheetCuttingPierceTime" ||
        _arg === "laserSheetCuttingRate" ||
        _arg === "laserSheetCuttingMinArea" ||
        _arg === "laserSheetCuttingMaxThickness" ||
        _arg === "packaging" ||
        _arg === "transportationCosts" ||
        _arg === "surcharge" ||
        _arg === "process" ||
        _arg === "processRate" ||
        _arg === "processSetupTimeFallback" ||
        _arg === "processUnitTimeFallback" ||
        _arg === "sheet" ||
        _arg === "sheetModulus" ||
        _arg === "sheetPrice" ||
        _arg === "upperDieGroup" ||
        _arg === "lowerDieGroup" ||
        _arg === "bendDeduction" ||
        _arg === "setting" ||
        _arg === "automaticMechanicalDeburringMaterial" ||
        _arg === "automaticMechanicalDeburringParameters" ||
        _arg === "dimensionConstraints" ||
        _arg === "screwThread" ||
        _arg === "tappingTimeParameters" ||
        _arg === "tubeMaterial" ||
        _arg === "tubeMaterialDensity" ||
        _arg === "tubeProfile" ||
        _arg === "tubeSpecification" ||
        _arg === "tube" ||
        _arg === "upperDie" ||
        _arg === "lowerDie" ||
        _arg === "upperDieUnit" ||
        _arg === "lowerDieUnit" ||
        _arg === "processHandlingTime" ||
        _arg === "sheetStock" ||
        _arg === "processIdlePeriod" ||
        _arg === "sheetMaterialScrapValue" ||
        _arg === "sheetPriority" ||
        _arg === "dieGroupPriority" ||
        _arg === "sheetCuttingMaterial" ||
        _arg === "sheetBendingMaterial" ||
        _arg === "tubeCuttingProcess" ||
        _arg === "tubeCuttingProcessMapping" ||
        _arg === "tubeCuttingSpeed" ||
        _arg === "tubeCuttingPierceTime" ||
        _arg === "tubePrice" ||
        _arg === "tubeStock" ||
        _arg === "tubeMaterialScrapValue";
}
export function isTableErrorType(_arg) {
    return _arg === "referringEntryMissing" ||
        _arg === "referredEntryMissing" ||
        _arg === "valueInvalid" ||
        _arg === "uniqueMemberCollision";
}
export function isFeature(_arg) {
    return _arg === "bendMeasurementScene" ||
        _arg === "bomExport" ||
        _arg === "graphRepExport" ||
        _arg === "unlimitedNumExports" ||
        _arg === "httpServiceUnfold" ||
        _arg === "httpServiceNestor" ||
        _arg === "httpServiceAssemblyTree" ||
        _arg === "lstExport" ||
        _arg === "erpInterfaceItBlech" ||
        _arg === "tubeDetection";
}
export function isReplyStateIndicatorPackaging(_arg) {
    return _arg === "undefinedError" ||
        _arg === "insufficientPackageVolume" ||
        _arg === "overweightParts";
}
export function isReplyStateIndicatorTransform(_arg) {
    return _arg === "undefinedError";
}
export function isReplyStateIndicatoruserDefined(_arg) {
    return _arg === "undefinedError";
}
export function isReplyStateIndicatoruserDefinedBase(_arg) {
    return _arg === "undefinedError";
}
export function isReplyStateIndicatorUndefined(_arg) {
    return _arg === "undefinedError";
}
export function isReplyStateIndicatorTubeCutting(_arg) {
    return _arg === "undefinedError" ||
        _arg === "undetectedFeatures";
}
export function isReplyStateIndicatorJoining(_arg) {
    return _arg === "undefinedError";
}
export function isReplyStateIndicatorSheet(_arg) {
    return _arg === "undefinedError" ||
        _arg === "nestingFailed";
}
export function isReplyStateIndicatorSheetCutting(_arg) {
    return _arg === "undefinedError" ||
        _arg === "undetectedFeatures" ||
        _arg === "multipleOuterContours" ||
        _arg === "unused0";
}
export function isReplyStateIndicatorSheetBending(_arg) {
    return _arg === "undefinedError" ||
        _arg === "multipleOuterContours" ||
        _arg === "contourInBend" ||
        _arg === "invalidBend" ||
        _arg === "undetectedFeatures";
}
export function isReplyStateIndicatorTube(_arg) {
    return _arg === "undefinedError";
}
export function isFileDialogType(_arg) {
    return _arg === "openFile" ||
        _arg === "openFiles" ||
        _arg === "saveFile" ||
        _arg === "directory";
}
export function isFormWidgetType(_arg) {
    return _arg === "checkBox" ||
        _arg === "spinBox" ||
        _arg === "dropDown" ||
        _arg === "lineEdit" ||
        _arg === "textEdit" ||
        _arg === "label";
}
export function isMessageBoxType(_arg) {
    return _arg === "info" ||
        _arg === "warning" ||
        _arg === "error" ||
        _arg === "question";
}
export function isGeometrySelectorConfigFlag(_arg) {
    return _arg === "edge" ||
        _arg === "face";
}
export function isWidgetType(_arg) {
    return _arg === "assemblyView" ||
        _arg === "attachmentEditor" ||
        _arg === "bendingToolEditor" ||
        _arg === "calcParamEditor" ||
        _arg === "fileDialog" ||
        _arg === "formEditor" ||
        _arg === "geometrySelector" ||
        _arg === "geometryColorSelector" ||
        _arg === "joiningSequenceEditor" ||
        _arg === "layeredImportDialog" ||
        _arg === "messageBox" ||
        _arg === "processSelector" ||
        _arg === "sheetFilterEditor" ||
        _arg === "sheetTappingEditor";
}
export function isSegmentType(_arg) {
    return _arg === "line" ||
        _arg === "arc";
}
export function isGeometryEntityType(_arg) {
    return _arg === "edge" ||
        _arg === "face";
}
export function isCamCommandType(_arg) {
    return _arg === "setColor";
}
export function isColor(_arg) {
    return _arg === "black" ||
        _arg === "white" ||
        _arg === "green" ||
        _arg === "yellow" ||
        _arg === "cyan" ||
        _arg === "blue" ||
        _arg === "magenta" ||
        _arg === "none" ||
        _arg === "red" ||
        _arg === "lightgrey" ||
        _arg === "lime" ||
        _arg === "turquoise" ||
        _arg === "violet" ||
        _arg === "saddlebrown" ||
        _arg === "darkorange" ||
        _arg === "sienna" ||
        _arg === "closedContour" ||
        _arg === "closedInnerContour" ||
        _arg === "closedOuterContour" ||
        _arg === "openContour" ||
        _arg === "engraving" ||
        _arg === "bendLine" ||
        _arg === "bendLineUp" ||
        _arg === "bendLineDown";
}
export function isStrokeStyle(_arg) {
    return _arg === "continuous" ||
        _arg === "dashed";
}
export function isPrivateGuiDataType(_arg) {
    return _arg === "graphRep";
}
export function isTwoDimImportResultType(_arg) {
    return _arg === "partInvalid" ||
        _arg === "engravingInvalid" ||
        _arg === "success";
}
export function isDatabasePermission(_arg) {
    return _arg === "read" ||
        _arg === "write";
}
export function isLocaleType(_arg) {
    return _arg === "language" ||
        _arg === "csv";
}
export function isAddResultStatus(_arg) {
    return _arg === "success" ||
        _arg === "unsupportedFormat" ||
        _arg === "versionMismatch" ||
        _arg === "inconsistentGraph" ||
        _arg === "undefinedError" ||
        _arg === "unsupportedVersion";
}
export function isTrumpfLoadingSystem(_arg) {
    return _arg === "manual" ||
        _arg === "paletteChange" ||
        _arg === "paletteChangeLiftMaster" ||
        _arg === "onePalette" ||
        _arg === "paletteChangeLiftMasterSort" ||
        _arg === "paletteChangeLiftMasterSortPullingDevice";
}
export function isLstEvaporateMode(_arg) {
    return _arg === "none" ||
        _arg === "early" ||
        _arg === "beforeEachPart";
}
export function isSheetCorner(_arg) {
    return _arg === "lowerLeft" ||
        _arg === "upperLeft" ||
        _arg === "lowerRight" ||
        _arg === "upperRight";
}
export function isGeometrySelectorConfigFlags(_arg) {
    return ((a) => { if (typeof a !== "object" || a === null) {
        return false;
    } for (const key in a) {
        if (!isGeometrySelectorConfigFlag(key)) {
            continue;
        }
        if (!((a) => typeof a === "boolean")(a[key])) {
            return false;
        }
    } return true; })(_arg);
}
export function isDatabasePermissions(_arg) {
    return ((a) => { if (typeof a !== "object" || a === null) {
        return false;
    } for (const key in a) {
        if (!isDatabasePermission(key)) {
            continue;
        }
        if (!((a) => typeof a === "boolean")(a[key])) {
            return false;
        }
    } return true; })(_arg);
}
export function isStringIndexedInterface(_arg) {
    if (typeof _arg !== "object" || _arg === null) {
        return false;
    }
    for (const key in _arg) {
        if (typeof key !== "string")
            return false;
    }
    return true;
}
export function isBendReplyStateContentUndefinedError(_arg) {
    return true;
}
export function isBendReplyStateContentContourInBend(_arg) {
    return true;
}
export function isBendReplyStateContentUndetectedFeatures(_arg) {
    return typeof _arg === "object" && _arg !== null && "unassignedFaceDescriptors" in _arg && ((a) => Array.isArray(a) && a.find((e) => !((a) => typeof a === "number")(e)) === undefined)(_arg.unassignedFaceDescriptors);
}
export function isBendReplyStateContentInvalidBend(_arg) {
    return true;
}
export function isBendReplyStateContentMultipleOuterContours(_arg) {
    return true;
}
export function isSheetCuttingReplyStateContentUndefinedError(_arg) {
    return true;
}
export function isSheetCuttingReplyStateContentUndetectedFeatures(_arg) {
    return typeof _arg === "object" && _arg !== null && "unassignedFaceDescriptors" in _arg && ((a) => Array.isArray(a) && a.find((e) => !((a) => typeof a === "number")(e)) === undefined)(_arg.unassignedFaceDescriptors);
}
export function isSheetCuttingReplyStateContentMultipleOuterContours(_arg) {
    return true;
}
export function isUnused(_arg) {
    return true;
}
export function isPackagingReplyStateContentUndefinedError(_arg) {
    return true;
}
export function isPackagingReplyStateContentInsufficientPackageVolume(_arg) {
    return true;
}
export function isPackagingReplyStateContentOverweightParts(_arg) {
    return true;
}
export function isTransformReplyStateContentUndefinedError(_arg) {
    return true;
}
export function isJoiningReplyStateContentUndefinedError(_arg) {
    return true;
}
export function isSheetReplyStateContentUndefinedError(_arg) {
    return true;
}
export function isSheetReplyStateContentNestingFailedError(_arg) {
    return true;
}
export function isUndefinedReplyStateContentUndefinedError(_arg) {
    return true;
}
export function isUserDefinedReplyStateContentUndefinedError(_arg) {
    return true;
}
export function isUserDefinedBaseReplyStateContentUndefinedError(_arg) {
    return true;
}
export function isTubeCuttingReplyStateContentUndefinedError(_arg) {
    return true;
}
export function isTubeCuttingReplyStateContentUndetectedFeatures(_arg) {
    return typeof _arg === "object" && _arg !== null && "unassignedFaceDescriptors" in _arg && ((a) => Array.isArray(a) && a.find((e) => !((a) => typeof a === "number")(e)) === undefined)(_arg.unassignedFaceDescriptors);
}
export function isTubeReplyStateContentUndefinedError(_arg) {
    return true;
}
export function isReplyStateMapSheet(_arg) {
    return typeof _arg === "object" && _arg !== null && !("undefinedError" in _arg) || ((a) => (a === undefined || isSheetReplyStateContentUndefinedError(a)))(_arg.undefinedError)
        && !("nestingFailed" in _arg) || ((a) => (a === undefined || isSheetReplyStateContentNestingFailedError(a)))(_arg.nestingFailed);
}
export function isReplyStateMapSheetBending(_arg) {
    return typeof _arg === "object" && _arg !== null && !("undefinedError" in _arg) || ((a) => (a === undefined || isBendReplyStateContentUndefinedError(a)))(_arg.undefinedError)
        && !("multipleOuterContours" in _arg) || ((a) => (a === undefined || isBendReplyStateContentMultipleOuterContours(a)))(_arg.multipleOuterContours)
        && !("contourInBend" in _arg) || ((a) => (a === undefined || isBendReplyStateContentContourInBend(a)))(_arg.contourInBend)
        && !("invalidBend" in _arg) || ((a) => (a === undefined || isBendReplyStateContentInvalidBend(a)))(_arg.invalidBend)
        && !("undetectedFeatures" in _arg) || ((a) => (a === undefined || isBendReplyStateContentUndetectedFeatures(a)))(_arg.undetectedFeatures);
}
export function isReplyStateMapJoining(_arg) {
    return typeof _arg === "object" && _arg !== null && !("undefinedError" in _arg) || ((a) => (a === undefined || isJoiningReplyStateContentUndefinedError(a)))(_arg.undefinedError);
}
export function isReplyStateMapSheetCutting(_arg) {
    return typeof _arg === "object" && _arg !== null && !("undefinedError" in _arg) || ((a) => (a === undefined || isSheetCuttingReplyStateContentUndefinedError(a)))(_arg.undefinedError)
        && !("undetectedFeatures" in _arg) || ((a) => (a === undefined || isSheetCuttingReplyStateContentUndetectedFeatures(a)))(_arg.undetectedFeatures)
        && !("multipleOuterContours" in _arg) || ((a) => (a === undefined || isSheetCuttingReplyStateContentMultipleOuterContours(a)))(_arg.multipleOuterContours)
        && !("unused0" in _arg) || ((a) => (a === undefined || isUnused(a)))(_arg.unused0);
}
export function isReplyStateMapPackaging(_arg) {
    return typeof _arg === "object" && _arg !== null && !("undefinedError" in _arg) || ((a) => (a === undefined || isPackagingReplyStateContentUndefinedError(a)))(_arg.undefinedError)
        && !("insufficientPackageVolume" in _arg) || ((a) => (a === undefined || isPackagingReplyStateContentInsufficientPackageVolume(a)))(_arg.insufficientPackageVolume)
        && !("overweightParts" in _arg) || ((a) => (a === undefined || isPackagingReplyStateContentOverweightParts(a)))(_arg.overweightParts);
}
export function isReplyStateMapTransform(_arg) {
    return typeof _arg === "object" && _arg !== null && !("undefinedError" in _arg) || ((a) => (a === undefined || isTransformReplyStateContentUndefinedError(a)))(_arg.undefinedError);
}
export function isReplyStateMapTube(_arg) {
    return typeof _arg === "object" && _arg !== null && !("undefinedError" in _arg) || ((a) => (a === undefined || isTubeReplyStateContentUndefinedError(a)))(_arg.undefinedError);
}
export function isReplyStateMapUndefined(_arg) {
    return typeof _arg === "object" && _arg !== null && !("undefinedError" in _arg) || ((a) => (a === undefined || isUndefinedReplyStateContentUndefinedError(a)))(_arg.undefinedError);
}
export function isReplyStateMapUserDefined(_arg) {
    return typeof _arg === "object" && _arg !== null && !("undefinedError" in _arg) || ((a) => (a === undefined || isUserDefinedReplyStateContentUndefinedError(a)))(_arg.undefinedError);
}
export function isReplyStateMapUserDefinedBase(_arg) {
    return typeof _arg === "object" && _arg !== null && !("undefinedError" in _arg) || ((a) => (a === undefined || isUserDefinedBaseReplyStateContentUndefinedError(a)))(_arg.undefinedError);
}
export function isReplyStateMapTubeCutting(_arg) {
    return typeof _arg === "object" && _arg !== null && !("undefinedError" in _arg) || ((a) => (a === undefined || isTubeCuttingReplyStateContentUndefinedError(a)))(_arg.undefinedError)
        && !("undetectedFeatures" in _arg) || ((a) => (a === undefined || isTubeCuttingReplyStateContentUndetectedFeatures(a)))(_arg.undetectedFeatures);
}
export function isReplyStateIndicatorsUndefined(_arg) {
    return typeof _arg === "object" && _arg !== null && "replyStateIndicators" in _arg && isReplyStateMapUndefined(_arg.replyStateIndicators);
}
export function isReplyStateIndicatorsSheet(_arg) {
    return typeof _arg === "object" && _arg !== null && "replyStateIndicators" in _arg && isReplyStateMapSheet(_arg.replyStateIndicators);
}
export function isReplyStateIndicatorsSheetCutting(_arg) {
    return typeof _arg === "object" && _arg !== null && "replyStateIndicators" in _arg && isReplyStateMapSheetCutting(_arg.replyStateIndicators);
}
export function isReplyStateIndicatorsJoining(_arg) {
    return typeof _arg === "object" && _arg !== null && "replyStateIndicators" in _arg && isReplyStateMapJoining(_arg.replyStateIndicators);
}
export function isReplyStateIndicatorsTubeCutting(_arg) {
    return typeof _arg === "object" && _arg !== null && "replyStateIndicators" in _arg && isReplyStateMapTubeCutting(_arg.replyStateIndicators);
}
export function isReplyStateIndicatorsUserDefined(_arg) {
    return typeof _arg === "object" && _arg !== null && "replyStateIndicators" in _arg && isReplyStateMapUserDefined(_arg.replyStateIndicators);
}
export function isReplyStateIndicatorsUserDefinedBase(_arg) {
    return typeof _arg === "object" && _arg !== null && "replyStateIndicators" in _arg && isReplyStateMapUserDefinedBase(_arg.replyStateIndicators);
}
export function isReplyStateIndicatorsSheetBending(_arg) {
    return typeof _arg === "object" && _arg !== null && "replyStateIndicators" in _arg && isReplyStateMapSheetBending(_arg.replyStateIndicators);
}
export function isReplyStateIndicatorsPackaging(_arg) {
    return typeof _arg === "object" && _arg !== null && "replyStateIndicators" in _arg && isReplyStateMapPackaging(_arg.replyStateIndicators);
}
export function isReplyStateIndicatorsTransform(_arg) {
    return typeof _arg === "object" && _arg !== null && "replyStateIndicators" in _arg && isReplyStateMapTransform(_arg.replyStateIndicators);
}
export function isReplyStateIndicatorsTube(_arg) {
    return typeof _arg === "object" && _arg !== null && "replyStateIndicators" in _arg && isReplyStateMapTube(_arg.replyStateIndicators);
}
export function isReplyStateIndicatorMap(_arg) {
    return typeof _arg === "object" && _arg !== null && !("undefined" in _arg) || ((a) => (a === undefined || isReplyStateIndicatorsUndefined(a)))(_arg.undefined)
        && !("sheet" in _arg) || ((a) => (a === undefined || isReplyStateIndicatorsSheet(a)))(_arg.sheet)
        && !("sheetCutting" in _arg) || ((a) => (a === undefined || isReplyStateIndicatorsSheetCutting(a)))(_arg.sheetCutting)
        && !("joining" in _arg) || ((a) => (a === undefined || isReplyStateIndicatorsJoining(a)))(_arg.joining)
        && !("tubeCutting" in _arg) || ((a) => (a === undefined || isReplyStateIndicatorsTubeCutting(a)))(_arg.tubeCutting)
        && !("sheetBending" in _arg) || ((a) => (a === undefined || isReplyStateIndicatorsSheetBending(a)))(_arg.sheetBending)
        && !("userDefined" in _arg) || ((a) => (a === undefined || isReplyStateIndicatorsUserDefined(a)))(_arg.userDefined)
        && !("userDefinedBase" in _arg) || ((a) => (a === undefined || isReplyStateIndicatorsUserDefinedBase(a)))(_arg.userDefinedBase)
        && !("packaging" in _arg) || ((a) => (a === undefined || isReplyStateIndicatorsPackaging(a)))(_arg.packaging)
        && !("transform" in _arg) || ((a) => (a === undefined || isReplyStateIndicatorsTransform(a)))(_arg.transform)
        && !("tube" in _arg) || ((a) => (a === undefined || isReplyStateIndicatorsTube(a)))(_arg.tube);
}
export function isCamNestedPart(_arg) {
    return typeof _arg === "object" && _arg !== null && "innerOuterPolygon" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.innerOuterPolygon)
        && "coordinateSystem" in _arg && isCoordinateSystem2(_arg.coordinateSystem);
}
export function isCamSheet(_arg) {
    return typeof _arg === "object" && _arg !== null && "dimX" in _arg && ((a) => typeof a === "number")(_arg.dimX)
        && "dimY" in _arg && ((a) => typeof a === "number")(_arg.dimY)
        && "multiplicity" in _arg && ((a) => typeof a === "number")(_arg.multiplicity);
}
export function isCamNesting(_arg) {
    return typeof _arg === "object" && _arg !== null && "sheets" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isCamSheet(e)) === undefined)(_arg.sheets);
}
export function isCamTubeNestingResultNesting(_arg) {
    return typeof _arg === "object" && _arg !== null && "transformations" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isCoordinateSystem3(e)) === undefined)(_arg.transformations)
        && "multiplicity" in _arg && ((a) => typeof a === "number")(_arg.multiplicity);
}
export function isCamTubeNestingResult(_arg) {
    return typeof _arg === "object" && _arg !== null && "inputLength" in _arg && ((a) => typeof a === "number")(_arg.inputLength)
        && "nestings" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isCamTubeNestingResultNesting(e)) === undefined)(_arg.nestings);
}
export function isBox2(_arg) {
    return typeof _arg === "object" && _arg !== null && "lower" in _arg && isPoint2(_arg.lower)
        && "upper" in _arg && isPoint2(_arg.upper);
}
export function isBox3(_arg) {
    return typeof _arg === "object" && _arg !== null && "lower" in _arg && isPoint3(_arg.lower)
        && "upper" in _arg && isPoint3(_arg.upper);
}
export function isPoint2(_arg) {
    return typeof _arg === "object" && _arg !== null && "entries" in _arg && ((a) => {
        const m = [
            ((a) => typeof a === "number"),
            ((a) => typeof a === "number"),
        ];
        return Array.isArray(a) && a.length === m.length && m.every((t, index) => t(a[index]));
    })(_arg.entries);
}
export function isPoint3(_arg) {
    return typeof _arg === "object" && _arg !== null && "entries" in _arg && ((a) => {
        const m = [
            ((a) => typeof a === "number"),
            ((a) => typeof a === "number"),
            ((a) => typeof a === "number"),
        ];
        return Array.isArray(a) && a.length === m.length && m.every((t, index) => t(a[index]));
    })(_arg.entries);
}
export function isVector2(_arg) {
    return typeof _arg === "object" && _arg !== null && "entries" in _arg && ((a) => {
        const m = [
            ((a) => typeof a === "number"),
            ((a) => typeof a === "number"),
        ];
        return Array.isArray(a) && a.length === m.length && m.every((t, index) => t(a[index]));
    })(_arg.entries);
}
export function isVector3(_arg) {
    return typeof _arg === "object" && _arg !== null && "entries" in _arg && ((a) => {
        const m = [
            ((a) => typeof a === "number"),
            ((a) => typeof a === "number"),
            ((a) => typeof a === "number"),
        ];
        return Array.isArray(a) && a.length === m.length && m.every((t, index) => t(a[index]));
    })(_arg.entries);
}
export function isVector4(_arg) {
    return typeof _arg === "object" && _arg !== null && "entries" in _arg && ((a) => {
        const m = [
            ((a) => typeof a === "number"),
            ((a) => typeof a === "number"),
            ((a) => typeof a === "number"),
            ((a) => typeof a === "number"),
        ];
        return Array.isArray(a) && a.length === m.length && m.every((t, index) => t(a[index]));
    })(_arg.entries);
}
export function isMatrix2(_arg) {
    return typeof _arg === "object" && _arg !== null && "entries" in _arg && ((a) => {
        const m = [
            ((a) => typeof a === "number"),
            ((a) => typeof a === "number"),
            ((a) => typeof a === "number"),
            ((a) => typeof a === "number"),
        ];
        return Array.isArray(a) && a.length === m.length && m.every((t, index) => t(a[index]));
    })(_arg.entries);
}
export function isMatrix3(_arg) {
    return typeof _arg === "object" && _arg !== null && "entries" in _arg && ((a) => {
        const m = [
            ((a) => typeof a === "number"),
            ((a) => typeof a === "number"),
            ((a) => typeof a === "number"),
            ((a) => typeof a === "number"),
            ((a) => typeof a === "number"),
            ((a) => typeof a === "number"),
            ((a) => typeof a === "number"),
            ((a) => typeof a === "number"),
            ((a) => typeof a === "number"),
        ];
        return Array.isArray(a) && a.length === m.length && m.every((t, index) => t(a[index]));
    })(_arg.entries);
}
export function isMatrix4(_arg) {
    return typeof _arg === "object" && _arg !== null && "entries" in _arg && ((a) => {
        const m = [
            ((a) => typeof a === "number"),
            ((a) => typeof a === "number"),
            ((a) => typeof a === "number"),
            ((a) => typeof a === "number"),
            ((a) => typeof a === "number"),
            ((a) => typeof a === "number"),
            ((a) => typeof a === "number"),
            ((a) => typeof a === "number"),
            ((a) => typeof a === "number"),
            ((a) => typeof a === "number"),
            ((a) => typeof a === "number"),
            ((a) => typeof a === "number"),
            ((a) => typeof a === "number"),
            ((a) => typeof a === "number"),
            ((a) => typeof a === "number"),
            ((a) => typeof a === "number"),
        ];
        return Array.isArray(a) && a.length === m.length && m.every((t, index) => t(a[index]));
    })(_arg.entries);
}
export function isCoordinateSystem2(_arg) {
    return typeof _arg === "object" && _arg !== null && "origin" in _arg && isVector2(_arg.origin)
        && "unitaryMatrix" in _arg && isMatrix2(_arg.unitaryMatrix);
}
export function isCoordinateSystem3(_arg) {
    return typeof _arg === "object" && _arg !== null && "origin" in _arg && isVector3(_arg.origin)
        && "unitaryMatrix" in _arg && isMatrix3(_arg.unitaryMatrix);
}
export function isConnectionProperties(_arg) {
    return typeof _arg === "object" && _arg !== null && "databaseType" in _arg && isDatabaseType(_arg.databaseType)
        && "name" in _arg && ((a) => typeof a === "string")(_arg.name)
        && "hostName" in _arg && ((a) => typeof a === "string")(_arg.hostName)
        && "port" in _arg && ((a) => typeof a === "number")(_arg.port)
        && "databaseName" in _arg && ((a) => typeof a === "string")(_arg.databaseName)
        && "userName" in _arg && ((a) => typeof a === "string")(_arg.userName)
        && "password" in _arg && ((a) => typeof a === "string")(_arg.password);
}
export function isArticleAttributes(_arg) {
    return typeof _arg === "object" && _arg !== null && "userData" in _arg && isStringIndexedInterface(_arg.userData);
}
export function isDieSelectorQuery(_arg) {
    return typeof _arg === "object" && _arg !== null && "thickness" in _arg && ((a) => typeof a === "number")(_arg.thickness)
        && "bendAngle" in _arg && ((a) => typeof a === "number")(_arg.bendAngle)
        && "maxOpeningWidth" in _arg && ((a) => typeof a === "number")(_arg.maxOpeningWidth);
}
export function isCamBendDeduction(_arg) {
    return typeof _arg === "object" && _arg !== null && "roundDeduction" in _arg && ((a) => typeof a === "number")(_arg.roundDeduction)
        && "innerRadius" in _arg && ((a) => typeof a === "number")(_arg.innerRadius);
}
export function isBendDieChoice(_arg) {
    return typeof _arg === "object" && _arg !== null && "baseClass" in _arg && isCamBendDeduction(_arg.baseClass)
        && "upperDieGroupId" in _arg && ((a) => typeof a === "string")(_arg.upperDieGroupId)
        && "lowerDieGroupId" in _arg && ((a) => typeof a === "string")(_arg.lowerDieGroupId)
        && "thickness" in _arg && ((a) => typeof a === "number")(_arg.thickness)
        && "type" in _arg && isBendDieChoiceType(_arg.type)
        && "sharpDeduction" in _arg && ((a) => typeof a === "number")(_arg.sharpDeduction);
}
export function isDieChoiceMapEntry(_arg) {
    return typeof _arg === "object" && _arg !== null && "bendDescriptor" in _arg && ((a) => typeof a === "number")(_arg.bendDescriptor)
        && "bendDieChoice" in _arg && isBendDieChoice(_arg.bendDieChoice);
}
export function isSceneObjectData(_arg) {
    return typeof _arg === "object" && _arg !== null && "zValue" in _arg && ((a) => typeof a === "number")(_arg.zValue)
        && "bendAngle" in _arg && ((a) => typeof a === "number")(_arg.bendAngle)
        && "innerRadius" in _arg && ((a) => typeof a === "number")(_arg.innerRadius)
        && "upperDieGroup" in _arg && ((a) => typeof a === "string")(_arg.upperDieGroup)
        && "lowerDieGroup" in _arg && ((a) => typeof a === "string")(_arg.lowerDieGroup)
        && "sharpDeduction" in _arg && ((a) => typeof a === "number")(_arg.sharpDeduction);
}
export function isSceneSceneData(_arg) {
    return typeof _arg === "object" && _arg !== null && "material" in _arg && ((a) => typeof a === "string")(_arg.material)
        && "thickness" in _arg && ((a) => typeof a === "number")(_arg.thickness)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier)
        && "comment" in _arg && ((a) => typeof a === "string")(_arg.comment)
        && "globalMaterial" in _arg && ((a) => typeof a === "string")(_arg.globalMaterial);
}
export function isSceneLabel(_arg) {
    return typeof _arg === "object" && _arg !== null && "position" in _arg && isPoint2(_arg.position)
        && "text" in _arg && ((a) => typeof a === "string")(_arg.text);
}
export function isLayer(_arg) {
    return typeof _arg === "object" && _arg !== null && "descriptor" in _arg && ((a) => typeof a === "number")(_arg.descriptor)
        && "number" in _arg && ((a) => typeof a === "number")(_arg.number)
        && "name" in _arg && ((a) => typeof a === "string")(_arg.name);
}
export function isAddResult(_arg) {
    return typeof _arg === "object" && _arg !== null && "id" in _arg && ((a) => typeof a === "string")(_arg.id)
        && "status" in _arg && isAddResultStatus(_arg.status)
        && "vertices" in _arg && ((a) => Array.isArray(a) && a.find((e) => !((a) => (typeof a === "object" && a !== null))(e)) === undefined)(_arg.vertices);
}
export function isBendLineData(_arg) {
    return typeof _arg === "object" && _arg !== null && "constructedInnerRadius" in _arg && ((a) => typeof a === "number")(_arg.constructedInnerRadius)
        && "resultingInnerRadius" in _arg && ((a) => typeof a === "number")(_arg.resultingInnerRadius)
        && "bendAngle" in _arg && ((a) => typeof a === "number")(_arg.bendAngle)
        && "bendDescriptor" in _arg && ((a) => typeof a === "number")(_arg.bendDescriptor)
        && "segments" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isSegment(e)) === undefined)(_arg.segments);
}
export function isBendLineFlangeLength(_arg) {
    return typeof _arg === "object" && _arg !== null && "flangeLengthLhs" in _arg && ((a) => typeof a === "number")(_arg.flangeLengthLhs)
        && "flangeLengthRhs" in _arg && ((a) => typeof a === "number")(_arg.flangeLengthRhs)
        && "bendDescriptor" in _arg && ((a) => typeof a === "number")(_arg.bendDescriptor);
}
export function isMeasurementScene(_arg) {
    return typeof _arg === "object" && _arg !== null && "scene" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.scene)
        && "camera" in _arg && isCamera3(_arg.camera);
}
export function isDocumentParagraph(_arg) {
    return typeof _arg === "object" && _arg !== null && "width" in _arg && ((a) => typeof a === "number")(_arg.width)
        && "text" in _arg && ((a) => typeof a === "string")(_arg.text)
        && "alignment" in _arg && isDocumentAlignment(_arg.alignment);
}
export function isDocumentSeparator(_arg) {
    return true;
}
export function isDocumentHeading(_arg) {
    return typeof _arg === "object" && _arg !== null && "level" in _arg && ((a) => typeof a === "number")(_arg.level)
        && "text" in _arg && ((a) => typeof a === "string")(_arg.text);
}
export function isDocumentBarcode(_arg) {
    return typeof _arg === "object" && _arg !== null && "width" in _arg && ((a) => typeof a === "number")(_arg.width)
        && "text" in _arg && ((a) => typeof a === "string")(_arg.text)
        && "alignment" in _arg && isDocumentAlignment(_arg.alignment);
}
export function isDocumentImage(_arg) {
    return typeof _arg === "object" && _arg !== null && "width" in _arg && ((a) => typeof a === "number")(_arg.width)
        && "type" in _arg && isDocumentImageType(_arg.type)
        && "uuid" in _arg && ((a) => typeof a === "string")(_arg.uuid)
        && "data" in _arg && ((a) => a instanceof ArrayBuffer)(_arg.data)
        && "alignment" in _arg && isDocumentAlignment(_arg.alignment);
}
export function isDocumentTable(_arg) {
    return typeof _arg === "object" && _arg !== null && "width" in _arg && ((a) => typeof a === "number")(_arg.width)
        && "columnWidths" in _arg && ((a) => Array.isArray(a) && a.find((e) => !((a) => typeof a === "number")(e)) === undefined)(_arg.columnWidths)
        && "columnHeaders" in _arg && isDocumentTableRow(_arg.columnHeaders)
        && "rows" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isDocumentTableRow(e)) === undefined)(_arg.rows);
}
export function isDocumentTableCell(_arg) {
    return typeof _arg === "object" && _arg !== null && "text" in _arg && ((a) => typeof a === "string")(_arg.text)
        && "alignment" in _arg && isDocumentAlignment(_arg.alignment);
}
export function isDocumentTableRow(_arg) {
    return true;
}
export function isDocumentPageBreak(_arg) {
    return true;
}
export function isDocumentItem(_arg) {
    return typeof _arg === "object" && _arg !== null && isDocumentItemType(_arg.type) && ((a) => (isDocumentParagraph(a) || isDocumentHeading(a) || isDocumentTable(a) || isDocumentImage(a) || isDocumentBarcode(a) || isDocumentSeparator(a) || isDocumentPageBreak(a)))(_arg.content);
}
export function isDocumentFormat(_arg) {
    return typeof _arg === "object" && _arg !== null && "orientation" in _arg && isDocumentOrientation(_arg.orientation);
}
export function isCamera3(_arg) {
    return typeof _arg === "object" && _arg !== null && "eye" in _arg && isPoint3(_arg.eye)
        && "center" in _arg && isPoint3(_arg.center)
        && "up" in _arg && isVector3(_arg.up);
}
export function isInputContentUndefined(_arg) {
    return true;
}
export function isInputContentDocumentGraph(_arg) {
    return typeof _arg === "object" && _arg !== null && "data" in _arg && ((a) => a instanceof ArrayBuffer)(_arg.data)
        && "id" in _arg && ((a) => typeof a === "string")(_arg.id);
}
export function isInputContentAssembly(_arg) {
    return typeof _arg === "object" && _arg !== null && "data" in _arg && ((a) => a instanceof ArrayBuffer)(_arg.data)
        && "id" in _arg && ((a) => typeof a === "string")(_arg.id);
}
export function isInputContentLayered(_arg) {
    return typeof _arg === "object" && _arg !== null && "data" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.data)
        && "thickness" in _arg && ((a) => typeof a === "number")(_arg.thickness)
        && "tolerance" in _arg && ((a) => typeof a === "number")(_arg.tolerance)
        && "name" in _arg && ((a) => typeof a === "string")(_arg.name)
        && "id" in _arg && ((a) => typeof a === "string")(_arg.id);
}
export function isInputContentTwoDimRep(_arg) {
    return typeof _arg === "object" && _arg !== null && "twoDimRep" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.twoDimRep)
        && "thickness" in _arg && ((a) => typeof a === "number")(_arg.thickness)
        && "name" in _arg && ((a) => typeof a === "string")(_arg.name)
        && "id" in _arg && ((a) => typeof a === "string")(_arg.id);
}
export function isInput(_arg) {
    return typeof _arg === "object" && _arg !== null && isInputType(_arg.type) && ((a) => (isInputContentUndefined(a) || isInputContentDocumentGraph(a) || isInputContentAssembly(a) || isInputContentLayered(a) || isInputContentTwoDimRep(a)))(_arg.content);
}
export function isIdRefPair(_arg) {
    return typeof _arg === "object" && _arg !== null && "id" in _arg && ((a) => typeof a === "string")(_arg.id)
        && "reference" in _arg && ((a) => (((a) => (typeof a === "object" && a !== null))(a) || ((a) => (typeof a === "object" && a !== null))(a) || ((a) => (typeof a === "object" && a !== null))(a)))(_arg.reference);
}
export function isCameraOrientation3(_arg) {
    return typeof _arg === "object" && _arg !== null && "center" in _arg && isVector3(_arg.center)
        && "direction" in _arg && isVector3(_arg.direction)
        && "up" in _arg && isVector3(_arg.up);
}
export function isJoiningStepEntry(_arg) {
    return typeof _arg === "object" && _arg !== null && "assembly" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.assembly);
}
export function isJoiningStep(_arg) {
    return typeof _arg === "object" && _arg !== null && "entries" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isJoiningStepEntry(e)) === undefined)(_arg.entries)
        && !("cameraOrientation" in _arg) || ((a) => (a === undefined || isCameraOrientation3(a)))(_arg.cameraOrientation)
        && "comment" in _arg && ((a) => typeof a === "string")(_arg.comment);
}
export function isJoining(_arg) {
    return typeof _arg === "object" && _arg !== null && "joiningSteps" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isJoiningStep(e)) === undefined)(_arg.joiningSteps);
}
export function isSheetFilter(_arg) {
    return typeof _arg === "object" && _arg !== null && "ids" in _arg && ((a) => Array.isArray(a) && a.find((e) => !((a) => typeof a === "string")(e)) === undefined)(_arg.ids);
}
export function isVertexWithProcessTypeData(_arg) {
    return typeof _arg === "object" && _arg !== null && "vertex" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.vertex)
        && "processId" in _arg && ((a) => typeof a === "string")(_arg.processId)
        && "forced" in _arg && ((a) => typeof a === "boolean")(_arg.forced);
}
export function isVertexWithUserData(_arg) {
    return typeof _arg === "object" && _arg !== null && "vertex" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.vertex)
        && "userData" in _arg && isStringIndexedInterface(_arg.userData);
}
export function isVertexWithMultiplicity(_arg) {
    return typeof _arg === "object" && _arg !== null && "vertex" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.vertex)
        && "multiplicity" in _arg && ((a) => typeof a === "number")(_arg.multiplicity);
}
export function isHandlerPackaging(_arg) {
    return typeof _arg === "object" && _arg !== null && "package" in _arg && isBox3(_arg.package)
        && "maxWeight" in _arg && ((a) => typeof a === "number")(_arg.maxWeight)
        && "masses" in _arg && ((a) => Array.isArray(a) && a.find((e) => !((a) => typeof a === "number")(e)) === undefined)(_arg.masses);
}
export function isHandlerPostProcessSheetBending(_arg) {
    return typeof _arg === "object" && _arg !== null && "upperDieAffectDistances" in _arg && ((a) => Array.isArray(a) && a.find((e) => !((a) => typeof a === "number")(e)) === undefined)(_arg.upperDieAffectDistances)
        && "lowerDieAffectDistances" in _arg && ((a) => Array.isArray(a) && a.find((e) => !((a) => typeof a === "number")(e)) === undefined)(_arg.lowerDieAffectDistances);
}
export function isVertexWithArticleAttributes(_arg) {
    return typeof _arg === "object" && _arg !== null && "vertex" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.vertex)
        && "articleAttributes" in _arg && isArticleAttributes(_arg.articleAttributes);
}
export function isHandlerPostProcessCreateSources(_arg) {
    return typeof _arg === "object" && _arg !== null && "attributes" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isVertexWithArticleAttributes(e)) === undefined)(_arg.attributes);
}
export function isHandlerPreProcessCreateWorkStep(_arg) {
    return typeof _arg === "object" && _arg !== null && "processTable" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isProcess(e)) === undefined)(_arg.processTable);
}
export function isPrivatePostProcessingResultCreateWorkStep(_arg) {
    return typeof _arg === "object" && _arg !== null && "processType" in _arg && isProcessType(_arg.processType)
        && "processId" in _arg && ((a) => typeof a === "string")(_arg.processId)
        && "userData" in _arg && isStringIndexedInterface(_arg.userData);
}
export function isPrivatePostProcessingResultCreateSourcesSheetCutting(_arg) {
    return typeof _arg === "object" && _arg !== null && "source" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.source)
        && "deducedDataOfSource" in _arg && isStringIndexedInterface(_arg.deducedDataOfSource);
}
export function isUiJoiningStepEntryRepresentation(_arg) {
    return typeof _arg === "object" && _arg !== null && "assembly" in _arg && ((a) => typeof a === "string")(_arg.assembly)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier);
}
export function isUiJoiningStepRepresentation(_arg) {
    return typeof _arg === "object" && _arg !== null && "entries" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isUiJoiningStepEntryRepresentation(e)) === undefined)(_arg.entries)
        && !("cameraOrientation" in _arg) || ((a) => (a === undefined || isCameraOrientation3(a)))(_arg.cameraOrientation)
        && "comment" in _arg && ((a) => typeof a === "string")(_arg.comment);
}
export function isUiJoiningRepresentation(_arg) {
    return typeof _arg === "object" && _arg !== null && "joiningSteps" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isUiJoiningStepRepresentation(e)) === undefined)(_arg.joiningSteps);
}
export function isAttachment(_arg) {
    return typeof _arg === "object" && _arg !== null && "name" in _arg && ((a) => typeof a === "string")(_arg.name)
        && "data" in _arg && ((a) => typeof a === "string")(_arg.data);
}
export function isFormWidgetCheckBoxConfig(_arg) {
    return typeof _arg === "object" && _arg !== null && "initialValue" in _arg && ((a) => typeof a === "boolean")(_arg.initialValue);
}
export function isFormWidgetSpinBoxConfig(_arg) {
    return typeof _arg === "object" && _arg !== null && "initialValue" in _arg && ((a) => typeof a === "number")(_arg.initialValue)
        && "min" in _arg && ((a) => typeof a === "number")(_arg.min)
        && "max" in _arg && ((a) => typeof a === "number")(_arg.max)
        && "decimals" in _arg && ((a) => typeof a === "number")(_arg.decimals);
}
export function isFormWidgetDropDownEntry(_arg) {
    return typeof _arg === "object" && _arg !== null && "id" in _arg && ((a) => typeof a === "string")(_arg.id)
        && "text" in _arg && ((a) => typeof a === "string")(_arg.text);
}
export function isFormWidgetDropDownConfig(_arg) {
    return typeof _arg === "object" && _arg !== null && "initialValue" in _arg && ((a) => typeof a === "string")(_arg.initialValue)
        && "entries" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isFormWidgetDropDownEntry(e)) === undefined)(_arg.entries);
}
export function isFormWidgetLineEditConfig(_arg) {
    return typeof _arg === "object" && _arg !== null && "initialValue" in _arg && ((a) => typeof a === "string")(_arg.initialValue);
}
export function isFormWidgetTextEditConfig(_arg) {
    return typeof _arg === "object" && _arg !== null && "initialValue" in _arg && ((a) => typeof a === "string")(_arg.initialValue);
}
export function isFormWidgetLabelConfig(_arg) {
    return typeof _arg === "object" && _arg !== null && "initialValue" in _arg && ((a) => typeof a === "string")(_arg.initialValue);
}
export function isFormWidgetConfig(_arg) {
    return typeof _arg === "object" && _arg !== null && isFormWidgetType(_arg.type) && ((a) => (isFormWidgetCheckBoxConfig(a) || isFormWidgetSpinBoxConfig(a) || isFormWidgetDropDownConfig(a) || isFormWidgetLineEditConfig(a) || isFormWidgetTextEditConfig(a) || isFormWidgetLabelConfig(a)))(_arg.content);
}
export function isFormRowConfig(_arg) {
    return typeof _arg === "object" && _arg !== null && "key" in _arg && ((a) => typeof a === "string")(_arg.key)
        && "name" in _arg && ((a) => typeof a === "string")(_arg.name)
        && "config" in _arg && isFormWidgetConfig(_arg.config);
}
export function isGeometrySelectionEntry(_arg) {
    return typeof _arg === "object" && _arg !== null && "entities" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isGeometryEntity(e)) === undefined)(_arg.entities)
        && "data" in _arg && isStringIndexedInterface(_arg.data);
}
export function isSheetTappingEditorCandidateValue(_arg) {
    return typeof _arg === "object" && _arg !== null && "id" in _arg && ((a) => typeof a === "string")(_arg.id)
        && "name" in _arg && ((a) => typeof a === "string")(_arg.name);
}
export function isSheetTappingEditorCandidate(_arg) {
    return typeof _arg === "object" && _arg !== null && "id" in _arg && ((a) => typeof a === "string")(_arg.id)
        && "name" in _arg && ((a) => typeof a === "string")(_arg.name)
        && "values" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isSheetTappingEditorCandidateValue(e)) === undefined)(_arg.values);
}
export function isSheetTappingEditorSelectionEntry(_arg) {
    return typeof _arg === "object" && _arg !== null && "candidateId" in _arg && ((a) => typeof a === "string")(_arg.candidateId)
        && "valueId" in _arg && ((a) => typeof a === "string")(_arg.valueId);
}
export function isUserDefinedScalePrice(_arg) {
    return typeof _arg === "object" && _arg !== null && "scaleValue" in _arg && ((a) => typeof a === "number")(_arg.scaleValue)
        && "price" in _arg && ((a) => typeof a === "number")(_arg.price);
}
export function isBendingToolEditorInputEntry(_arg) {
    return typeof _arg === "object" && _arg !== null && "bendDescriptor" in _arg && ((a) => typeof a === "number")(_arg.bendDescriptor)
        && "angle" in _arg && ((a) => typeof a === "number")(_arg.angle)
        && "constructedInnerRadius" in _arg && ((a) => typeof a === "number")(_arg.constructedInnerRadius)
        && "bendDieChoices" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isBendDieChoice(e)) === undefined)(_arg.bendDieChoices);
}
export function isWidgetConfigAssemblyView(_arg) {
    return typeof _arg === "object" && _arg !== null && "assembly" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.assembly);
}
export function isWidgetConfigAttachmentEditor(_arg) {
    return typeof _arg === "object" && _arg !== null && "initialValue" in _arg && isWidgetResultAttachmentEditor(_arg.initialValue);
}
export function isWidgetConfigBendingToolEditor(_arg) {
    return typeof _arg === "object" && _arg !== null && "input" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isBendingToolEditorInputEntry(e)) === undefined)(_arg.input)
        && "initialValue" in _arg && isWidgetResultBendingToolEditor(_arg.initialValue);
}
export function isWidgetConfigCalcParamEditor(_arg) {
    return typeof _arg === "object" && _arg !== null && "initialValue" in _arg && isWidgetResultCalcParamEditor(_arg.initialValue);
}
export function isWidgetConfigFileDialog(_arg) {
    return typeof _arg === "object" && _arg !== null && "type" in _arg && isFileDialogType(_arg.type)
        && "title" in _arg && ((a) => typeof a === "string")(_arg.title)
        && "defaultPath" in _arg && ((a) => typeof a === "string")(_arg.defaultPath)
        && "filter" in _arg && ((a) => typeof a === "string")(_arg.filter);
}
export function isWidgetConfigFormEditor(_arg) {
    return typeof _arg === "object" && _arg !== null && "rows" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isFormRowConfig(e)) === undefined)(_arg.rows);
}
export function isWidgetConfigGeometrySelector(_arg) {
    return typeof _arg === "object" && _arg !== null && "flags" in _arg && isGeometrySelectorConfigFlags(_arg.flags)
        && "assembly" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.assembly)
        && "formEditorConfig" in _arg && isWidgetConfigFormEditor(_arg.formEditorConfig)
        && "initialValue" in _arg && isWidgetResultGeometrySelector(_arg.initialValue);
}
export function isWidgetConfigGeometryColorSelector(_arg) {
    return typeof _arg === "object" && _arg !== null && "flags" in _arg && isGeometrySelectorConfigFlags(_arg.flags)
        && "assembly" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.assembly)
        && "formEditorConfig" in _arg && isWidgetConfigFormEditor(_arg.formEditorConfig)
        && "colorDataKey" in _arg && ((a) => typeof a === "string")(_arg.colorDataKey)
        && "initialValue" in _arg && isWidgetResultGeometryColorSelector(_arg.initialValue);
}
export function isAssemblyMapEntry(_arg) {
    return typeof _arg === "object" && _arg !== null && "id" in _arg && ((a) => typeof a === "string")(_arg.id)
        && "assembly" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.assembly);
}
export function isWidgetConfigJoiningSequenceEditor(_arg) {
    return typeof _arg === "object" && _arg !== null && "articleName" in _arg && ((a) => typeof a === "string")(_arg.articleName)
        && "assemblyMap" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isAssemblyMapEntry(e)) === undefined)(_arg.assemblyMap)
        && "initialValue" in _arg && isWidgetResultJoiningSequenceEditor(_arg.initialValue);
}
export function isWidgetConfigLayeredImportDialog(_arg) {
    return typeof _arg === "object" && _arg !== null && "title" in _arg && ((a) => typeof a === "string")(_arg.title)
        && "layered" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.layered)
        && "thickness" in _arg && ((a) => typeof a === "number")(_arg.thickness)
        && "name" in _arg && ((a) => typeof a === "string")(_arg.name)
        && "material" in _arg && ((a) => typeof a === "string")(_arg.material);
}
export function isWidgetConfigMessageBox(_arg) {
    return typeof _arg === "object" && _arg !== null && "type" in _arg && isMessageBoxType(_arg.type)
        && "title" in _arg && ((a) => typeof a === "string")(_arg.title)
        && "text" in _arg && ((a) => typeof a === "string")(_arg.text);
}
export function isWidgetConfigProcessSelector(_arg) {
    return typeof _arg === "object" && _arg !== null && "processTable" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isProcess(e)) === undefined)(_arg.processTable)
        && "supportedWorkStepTypes" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isWorkStepType(e)) === undefined)(_arg.supportedWorkStepTypes)
        && "initialValue" in _arg && isWidgetResultProcessSelector(_arg.initialValue);
}
export function isWidgetConfigSheetFilterEditor(_arg) {
    return typeof _arg === "object" && _arg !== null && "sheets" in _arg && ((a) => Array.isArray(a) && a.find((e) => !((a) => typeof a === "string")(e)) === undefined)(_arg.sheets)
        && "initialValue" in _arg && isWidgetResultSheetFilterEditor(_arg.initialValue);
}
export function isWidgetConfigSheetTappingEditor(_arg) {
    return typeof _arg === "object" && _arg !== null && "base64Scene" in _arg && ((a) => typeof a === "string")(_arg.base64Scene)
        && "candidates" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isSheetTappingEditorCandidate(e)) === undefined)(_arg.candidates)
        && "initialValue" in _arg && isWidgetResultSheetTappingEditor(_arg.initialValue);
}
export function isWidgetConfig(_arg) {
    return typeof _arg === "object" && _arg !== null && isWidgetType(_arg.type) && ((a) => (isWidgetConfigAssemblyView(a) || isWidgetConfigAttachmentEditor(a) || isWidgetConfigBendingToolEditor(a) || isWidgetConfigCalcParamEditor(a) || isWidgetConfigFileDialog(a) || isWidgetConfigFormEditor(a) || isWidgetConfigGeometrySelector(a) || isWidgetConfigGeometryColorSelector(a) || isWidgetConfigJoiningSequenceEditor(a) || isWidgetConfigLayeredImportDialog(a) || isWidgetConfigMessageBox(a) || isWidgetConfigProcessSelector(a) || isWidgetConfigSheetFilterEditor(a) || isWidgetConfigSheetTappingEditor(a)))(_arg.content);
}
export function isWidgetResultAssemblyView(_arg) {
    return true;
}
export function isWidgetResultAttachmentEditor(_arg) {
    return typeof _arg === "object" && _arg !== null && "attachments" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isAttachment(e)) === undefined)(_arg.attachments);
}
export function isWidgetResultBendingToolEditor(_arg) {
    return typeof _arg === "object" && _arg !== null && "dieChoiceMap" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isDieChoiceMapEntry(e)) === undefined)(_arg.dieChoiceMap);
}
export function isWidgetResultCalcParamEditor(_arg) {
    return typeof _arg === "object" && _arg !== null && !("materialCostsPerPiece" in _arg) || ((a) => (a === undefined || ((a) => typeof a === "number")(a)))(_arg.materialCostsPerPiece)
        && !("setupTime" in _arg) || ((a) => (a === undefined || ((a) => typeof a === "number")(a)))(_arg.setupTime)
        && !("unitTimePerPiece" in _arg) || ((a) => (a === undefined || ((a) => typeof a === "number")(a)))(_arg.unitTimePerPiece)
        && "userDefinedScalePrices" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isUserDefinedScalePrice(e)) === undefined)(_arg.userDefinedScalePrices);
}
export function isWidgetResultFileDialog(_arg) {
    return typeof _arg === "object" && _arg !== null && "paths" in _arg && ((a) => Array.isArray(a) && a.find((e) => !((a) => typeof a === "string")(e)) === undefined)(_arg.paths);
}
export function isWidgetResultFormEditor(_arg) {
    return typeof _arg === "object" && _arg !== null && "values" in _arg && isStringIndexedInterface(_arg.values);
}
export function isWidgetResultGeometrySelector(_arg) {
    return typeof _arg === "object" && _arg !== null && "selection" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isGeometrySelectionEntry(e)) === undefined)(_arg.selection);
}
export function isWidgetResultGeometryColorSelector(_arg) {
    return typeof _arg === "object" && _arg !== null && "selection" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isGeometrySelectionEntry(e)) === undefined)(_arg.selection);
}
export function isWidgetResultJoiningSequenceEditor(_arg) {
    return typeof _arg === "object" && _arg !== null && "joining" in _arg && isUiJoiningRepresentation(_arg.joining);
}
export function isWidgetResultLayeredImportDialog(_arg) {
    return typeof _arg === "object" && _arg !== null && "twoDimRep" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.twoDimRep)
        && "thickness" in _arg && ((a) => typeof a === "number")(_arg.thickness);
}
export function isWidgetResultMessageBox(_arg) {
    return typeof _arg === "object" && _arg !== null && "accepted" in _arg && ((a) => typeof a === "boolean")(_arg.accepted);
}
export function isWidgetResultProcessSelector(_arg) {
    return typeof _arg === "object" && _arg !== null && "processId" in _arg && ((a) => typeof a === "string")(_arg.processId)
        && "forced" in _arg && ((a) => typeof a === "boolean")(_arg.forced);
}
export function isWidgetResultSheetFilterEditor(_arg) {
    return typeof _arg === "object" && _arg !== null && "filter" in _arg && isSheetFilter(_arg.filter);
}
export function isWidgetResultSheetTappingEditor(_arg) {
    return typeof _arg === "object" && _arg !== null && "selection" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isSheetTappingEditorSelectionEntry(e)) === undefined)(_arg.selection);
}
export function isWidgetResult(_arg) {
    return typeof _arg === "object" && _arg !== null && isWidgetType(_arg.type) && ((a) => (isWidgetResultAssemblyView(a) || isWidgetResultAttachmentEditor(a) || isWidgetResultBendingToolEditor(a) || isWidgetResultCalcParamEditor(a) || isWidgetResultFileDialog(a) || isWidgetResultFormEditor(a) || isWidgetResultGeometrySelector(a) || isWidgetResultGeometryColorSelector(a) || isWidgetResultJoiningSequenceEditor(a) || isWidgetResultLayeredImportDialog(a) || isWidgetResultMessageBox(a) || isWidgetResultProcessSelector(a) || isWidgetResultSheetFilterEditor(a) || isWidgetResultSheetTappingEditor(a)))(_arg.content);
}
export function isTubeProfileGeometryRectangular(_arg) {
    return typeof _arg === "object" && _arg !== null && "dimY" in _arg && ((a) => typeof a === "number")(_arg.dimY)
        && "dimZ" in _arg && ((a) => typeof a === "number")(_arg.dimZ)
        && "thickness" in _arg && ((a) => typeof a === "number")(_arg.thickness);
}
export function isTubeProfileGeometryCircular(_arg) {
    return typeof _arg === "object" && _arg !== null && "outerRadius" in _arg && ((a) => typeof a === "number")(_arg.outerRadius)
        && "thickness" in _arg && ((a) => typeof a === "number")(_arg.thickness);
}
export function isTubeProfileGeometry(_arg) {
    return typeof _arg === "object" && _arg !== null && isTubeProfileGeometryType(_arg.type) && ((a) => (isTubeProfileGeometryRectangular(a) || isTubeProfileGeometryCircular(a)))(_arg.content);
}
export function isNest2PartInstance(_arg) {
    return typeof _arg === "object" && _arg !== null && "descriptor" in _arg && ((a) => typeof a === "number")(_arg.descriptor)
        && "transformation" in _arg && isCoordinateSystem2(_arg.transformation);
}
export function isSheetMaterialUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier);
}
export function isSheetMaterial(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier)
        && "name" in _arg && ((a) => typeof a === "string")(_arg.name)
        && "description" in _arg && ((a) => typeof a === "string")(_arg.description);
}
export function isSheetMaterialDensityUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetMaterialId" in _arg && ((a) => typeof a === "string")(_arg.sheetMaterialId);
}
export function isSheetMaterialDensity(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetMaterialId" in _arg && ((a) => typeof a === "string")(_arg.sheetMaterialId)
        && "density" in _arg && ((a) => typeof a === "number")(_arg.density);
}
export function isSheetCuttingMaterialMappingUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetMaterialId" in _arg && ((a) => typeof a === "string")(_arg.sheetMaterialId);
}
export function isSheetCuttingMaterialMapping(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetMaterialId" in _arg && ((a) => typeof a === "string")(_arg.sheetMaterialId)
        && "sheetCuttingMaterialId" in _arg && ((a) => typeof a === "string")(_arg.sheetCuttingMaterialId);
}
export function isSheetBendingMaterialMappingUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetMaterialId" in _arg && ((a) => typeof a === "string")(_arg.sheetMaterialId);
}
export function isSheetBendingMaterialMapping(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetMaterialId" in _arg && ((a) => typeof a === "string")(_arg.sheetMaterialId)
        && "sheetBendingMaterialId" in _arg && ((a) => typeof a === "string")(_arg.sheetBendingMaterialId);
}
export function isBendTimeUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "mass" in _arg && ((a) => typeof a === "number")(_arg.mass);
}
export function isBendTime(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "mass" in _arg && ((a) => typeof a === "number")(_arg.mass)
        && "setupTime" in _arg && ((a) => typeof a === "number")(_arg.setupTime)
        && "setupTimePerBend" in _arg && ((a) => typeof a === "number")(_arg.setupTimePerBend)
        && "unitTime" in _arg && ((a) => typeof a === "number")(_arg.unitTime)
        && "unitTimePerBend" in _arg && ((a) => typeof a === "number")(_arg.unitTimePerBend);
}
export function isBendTimeParametersUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetBendingMaterialId" in _arg && ((a) => typeof a === "string")(_arg.sheetBendingMaterialId)
        && "thickness" in _arg && ((a) => typeof a === "number")(_arg.thickness)
        && "bendLineNetLength" in _arg && ((a) => typeof a === "number")(_arg.bendLineNetLength);
}
export function isBendTimeParameters(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetBendingMaterialId" in _arg && ((a) => typeof a === "string")(_arg.sheetBendingMaterialId)
        && "thickness" in _arg && ((a) => typeof a === "number")(_arg.thickness)
        && "bendLineNetLength" in _arg && ((a) => typeof a === "number")(_arg.bendLineNetLength)
        && "setupTimeFactor" in _arg && ((a) => typeof a === "number")(_arg.setupTimeFactor)
        && "setupTimeDelta" in _arg && ((a) => typeof a === "number")(_arg.setupTimeDelta)
        && "setupTimePerBendFactor" in _arg && ((a) => typeof a === "number")(_arg.setupTimePerBendFactor)
        && "setupTimePerBendDelta" in _arg && ((a) => typeof a === "number")(_arg.setupTimePerBendDelta)
        && "unitTimeFactor" in _arg && ((a) => typeof a === "number")(_arg.unitTimeFactor)
        && "unitTimeDelta" in _arg && ((a) => typeof a === "number")(_arg.unitTimeDelta)
        && "unitTimePerBendFactor" in _arg && ((a) => typeof a === "number")(_arg.unitTimePerBendFactor)
        && "unitTimePerBendDelta" in _arg && ((a) => typeof a === "number")(_arg.unitTimePerBendDelta);
}
export function isBendRateParametersUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetBendingMaterialId" in _arg && ((a) => typeof a === "string")(_arg.sheetBendingMaterialId)
        && "thickness" in _arg && ((a) => typeof a === "number")(_arg.thickness)
        && "bendLineNetLength" in _arg && ((a) => typeof a === "number")(_arg.bendLineNetLength);
}
export function isBendRateParameters(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetBendingMaterialId" in _arg && ((a) => typeof a === "string")(_arg.sheetBendingMaterialId)
        && "thickness" in _arg && ((a) => typeof a === "number")(_arg.thickness)
        && "bendLineNetLength" in _arg && ((a) => typeof a === "number")(_arg.bendLineNetLength)
        && "hourlyRateFactor" in _arg && ((a) => typeof a === "number")(_arg.hourlyRateFactor)
        && "hourlyRateDelta" in _arg && ((a) => typeof a === "number")(_arg.hourlyRateDelta);
}
export function isBendLineConstraintUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetBendingMaterialId" in _arg && ((a) => typeof a === "string")(_arg.sheetBendingMaterialId)
        && "thickness" in _arg && ((a) => typeof a === "number")(_arg.thickness);
}
export function isBendLineConstraint(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetBendingMaterialId" in _arg && ((a) => typeof a === "string")(_arg.sheetBendingMaterialId)
        && "thickness" in _arg && ((a) => typeof a === "number")(_arg.thickness)
        && "maxNetLength" in _arg && ((a) => typeof a === "number")(_arg.maxNetLength);
}
export function isLaserSheetCuttingGasUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier);
}
export function isLaserSheetCuttingGas(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier)
        && "name" in _arg && ((a) => typeof a === "string")(_arg.name);
}
export function isLaserSheetCuttingSpeedUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetCuttingMaterialId" in _arg && ((a) => typeof a === "string")(_arg.sheetCuttingMaterialId)
        && "laserSheetCuttingGasId" in _arg && ((a) => typeof a === "string")(_arg.laserSheetCuttingGasId)
        && "thickness" in _arg && ((a) => typeof a === "number")(_arg.thickness);
}
export function isLaserSheetCuttingSpeed(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetCuttingMaterialId" in _arg && ((a) => typeof a === "string")(_arg.sheetCuttingMaterialId)
        && "laserSheetCuttingGasId" in _arg && ((a) => typeof a === "string")(_arg.laserSheetCuttingGasId)
        && "thickness" in _arg && ((a) => typeof a === "number")(_arg.thickness)
        && "speed" in _arg && ((a) => typeof a === "number")(_arg.speed);
}
export function isLaserSheetCuttingPierceTimeUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetCuttingMaterialId" in _arg && ((a) => typeof a === "string")(_arg.sheetCuttingMaterialId)
        && "laserSheetCuttingGasId" in _arg && ((a) => typeof a === "string")(_arg.laserSheetCuttingGasId)
        && "thickness" in _arg && ((a) => typeof a === "number")(_arg.thickness);
}
export function isLaserSheetCuttingPierceTime(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetCuttingMaterialId" in _arg && ((a) => typeof a === "string")(_arg.sheetCuttingMaterialId)
        && "laserSheetCuttingGasId" in _arg && ((a) => typeof a === "string")(_arg.laserSheetCuttingGasId)
        && "thickness" in _arg && ((a) => typeof a === "number")(_arg.thickness)
        && "time" in _arg && ((a) => typeof a === "number")(_arg.time);
}
export function isLaserSheetCuttingRateUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetCuttingMaterialId" in _arg && ((a) => typeof a === "string")(_arg.sheetCuttingMaterialId)
        && "laserSheetCuttingGasId" in _arg && ((a) => typeof a === "string")(_arg.laserSheetCuttingGasId);
}
export function isLaserSheetCuttingRate(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetCuttingMaterialId" in _arg && ((a) => typeof a === "string")(_arg.sheetCuttingMaterialId)
        && "laserSheetCuttingGasId" in _arg && ((a) => typeof a === "string")(_arg.laserSheetCuttingGasId)
        && "rate" in _arg && ((a) => typeof a === "number")(_arg.rate);
}
export function isLaserSheetCuttingMinAreaUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetCuttingMaterialId" in _arg && ((a) => typeof a === "string")(_arg.sheetCuttingMaterialId)
        && "laserSheetCuttingGasId" in _arg && ((a) => typeof a === "string")(_arg.laserSheetCuttingGasId)
        && "thickness" in _arg && ((a) => typeof a === "number")(_arg.thickness);
}
export function isLaserSheetCuttingMinArea(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetCuttingMaterialId" in _arg && ((a) => typeof a === "string")(_arg.sheetCuttingMaterialId)
        && "laserSheetCuttingGasId" in _arg && ((a) => typeof a === "string")(_arg.laserSheetCuttingGasId)
        && "thickness" in _arg && ((a) => typeof a === "number")(_arg.thickness)
        && "area" in _arg && ((a) => typeof a === "number")(_arg.area);
}
export function isLaserSheetCuttingMaxThicknessUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetCuttingMaterialId" in _arg && ((a) => typeof a === "string")(_arg.sheetCuttingMaterialId)
        && "laserSheetCuttingGasId" in _arg && ((a) => typeof a === "string")(_arg.laserSheetCuttingGasId);
}
export function isLaserSheetCuttingMaxThickness(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetCuttingMaterialId" in _arg && ((a) => typeof a === "string")(_arg.sheetCuttingMaterialId)
        && "laserSheetCuttingGasId" in _arg && ((a) => typeof a === "string")(_arg.laserSheetCuttingGasId)
        && "maxThickness" in _arg && ((a) => typeof a === "number")(_arg.maxThickness)
        && "minThickness" in _arg && ((a) => typeof a === "number")(_arg.minThickness);
}
export function isPackagingUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier);
}
export function isPackaging(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier)
        && "name" in _arg && ((a) => typeof a === "string")(_arg.name)
        && "dimX" in _arg && ((a) => typeof a === "number")(_arg.dimX)
        && "dimY" in _arg && ((a) => typeof a === "number")(_arg.dimY)
        && "dimZ" in _arg && ((a) => typeof a === "number")(_arg.dimZ)
        && "maxWeight" in _arg && ((a) => typeof a === "number")(_arg.maxWeight)
        && "price" in _arg && ((a) => typeof a === "number")(_arg.price)
        && "tr" in _arg && ((a) => typeof a === "number")(_arg.tr)
        && "tep" in _arg && ((a) => typeof a === "number")(_arg.tep)
        && "tea" in _arg && ((a) => typeof a === "number")(_arg.tea)
        && "packagingWeight" in _arg && ((a) => typeof a === "number")(_arg.packagingWeight);
}
export function isTransportationCostsUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier);
}
export function isTransportationCosts(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier)
        && "name" in _arg && ((a) => typeof a === "string")(_arg.name)
        && "packagingId" in _arg && ((a) => typeof a === "string")(_arg.packagingId)
        && "fixedCosts" in _arg && ((a) => typeof a === "number")(_arg.fixedCosts)
        && "minCosts" in _arg && ((a) => typeof a === "number")(_arg.minCosts)
        && "kmKgFactor" in _arg && ((a) => typeof a === "number")(_arg.kmKgFactor)
        && "kmFactor" in _arg && ((a) => typeof a === "number")(_arg.kmFactor)
        && "minDistance" in _arg && ((a) => typeof a === "number")(_arg.minDistance)
        && "maxDistance" in _arg && ((a) => typeof a === "number")(_arg.maxDistance);
}
export function isSurchargeUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "name" in _arg && ((a) => typeof a === "string")(_arg.name)
        && "type" in _arg && ((a) => typeof a === "string")(_arg.type)
        && "value" in _arg && ((a) => typeof a === "number")(_arg.value);
}
export function isSurcharge(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "name" in _arg && ((a) => typeof a === "string")(_arg.name)
        && "type" in _arg && ((a) => typeof a === "string")(_arg.type)
        && "value" in _arg && ((a) => typeof a === "number")(_arg.value)
        && "description" in _arg && ((a) => typeof a === "string")(_arg.description);
}
export function isProcessUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier);
}
export function isProcess(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier)
        && "parentIdentifier" in _arg && ((a) => typeof a === "string")(_arg.parentIdentifier)
        && "type" in _arg && isProcessType(_arg.type)
        && "name" in _arg && ((a) => typeof a === "string")(_arg.name)
        && "costCenter" in _arg && ((a) => typeof a === "string")(_arg.costCenter)
        && "active" in _arg && ((a) => typeof a === "boolean")(_arg.active)
        && "childrenActive" in _arg && ((a) => typeof a === "boolean")(_arg.childrenActive)
        && "description" in _arg && ((a) => typeof a === "string")(_arg.description);
}
export function isProcessRateUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "processId" in _arg && ((a) => typeof a === "string")(_arg.processId);
}
export function isProcessRate(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "processId" in _arg && ((a) => typeof a === "string")(_arg.processId)
        && "rate" in _arg && ((a) => typeof a === "number")(_arg.rate);
}
export function isProcessSetupTimeFallbackUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "processId" in _arg && ((a) => typeof a === "string")(_arg.processId);
}
export function isProcessSetupTimeFallback(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "processId" in _arg && ((a) => typeof a === "string")(_arg.processId)
        && "time" in _arg && ((a) => typeof a === "number")(_arg.time);
}
export function isProcessUnitTimeFallbackUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "processId" in _arg && ((a) => typeof a === "string")(_arg.processId);
}
export function isProcessUnitTimeFallback(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "processId" in _arg && ((a) => typeof a === "string")(_arg.processId)
        && "time" in _arg && ((a) => typeof a === "number")(_arg.time);
}
export function isSheetUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier);
}
export function isSheet(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier)
        && "name" in _arg && ((a) => typeof a === "string")(_arg.name)
        && "sheetMaterialId" in _arg && ((a) => typeof a === "string")(_arg.sheetMaterialId)
        && "dimX" in _arg && ((a) => typeof a === "number")(_arg.dimX)
        && "dimY" in _arg && ((a) => typeof a === "number")(_arg.dimY)
        && "thickness" in _arg && ((a) => typeof a === "number")(_arg.thickness)
        && "description" in _arg && ((a) => typeof a === "string")(_arg.description);
}
export function isSheetModulusUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetId" in _arg && ((a) => typeof a === "string")(_arg.sheetId);
}
export function isSheetModulus(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetId" in _arg && ((a) => typeof a === "string")(_arg.sheetId)
        && "xModulus" in _arg && ((a) => typeof a === "number")(_arg.xModulus)
        && "yModulus" in _arg && ((a) => typeof a === "number")(_arg.yModulus)
        && "applyToAll" in _arg && ((a) => typeof a === "boolean")(_arg.applyToAll);
}
export function isSheetPriceUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetId" in _arg && ((a) => typeof a === "string")(_arg.sheetId);
}
export function isSheetPrice(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetId" in _arg && ((a) => typeof a === "string")(_arg.sheetId)
        && "pricePerSheet" in _arg && ((a) => typeof a === "number")(_arg.pricePerSheet);
}
export function isUpperDieGroupUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier);
}
export function isUpperDieGroup(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier)
        && "name" in _arg && ((a) => typeof a === "string")(_arg.name)
        && "exportIdentifier" in _arg && ((a) => typeof a === "string")(_arg.exportIdentifier)
        && "radius" in _arg && ((a) => typeof a === "number")(_arg.radius);
}
export function isLowerDieGroupUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier);
}
export function isLowerDieGroup(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier)
        && "name" in _arg && ((a) => typeof a === "string")(_arg.name)
        && "exportIdentifier" in _arg && ((a) => typeof a === "string")(_arg.exportIdentifier)
        && "openingWidth" in _arg && ((a) => typeof a === "number")(_arg.openingWidth);
}
export function isBendDeductionUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetBendingMaterialId" in _arg && ((a) => typeof a === "string")(_arg.sheetBendingMaterialId)
        && "upperDieGroupId" in _arg && ((a) => typeof a === "string")(_arg.upperDieGroupId)
        && "lowerDieGroupId" in _arg && ((a) => typeof a === "string")(_arg.lowerDieGroupId)
        && "thickness" in _arg && ((a) => typeof a === "number")(_arg.thickness)
        && "bendAngle" in _arg && ((a) => typeof a === "number")(_arg.bendAngle);
}
export function isBendDeduction(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetBendingMaterialId" in _arg && ((a) => typeof a === "string")(_arg.sheetBendingMaterialId)
        && "upperDieGroupId" in _arg && ((a) => typeof a === "string")(_arg.upperDieGroupId)
        && "lowerDieGroupId" in _arg && ((a) => typeof a === "string")(_arg.lowerDieGroupId)
        && "thickness" in _arg && ((a) => typeof a === "number")(_arg.thickness)
        && "bendAngle" in _arg && ((a) => typeof a === "number")(_arg.bendAngle)
        && "innerRadius" in _arg && ((a) => typeof a === "number")(_arg.innerRadius)
        && "sharpDeduction" in _arg && ((a) => typeof a === "number")(_arg.sharpDeduction);
}
export function isSettingUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "key" in _arg && ((a) => typeof a === "string")(_arg.key);
}
export function isSetting(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "key" in _arg && ((a) => typeof a === "string")(_arg.key)
        && "value" in _arg && ((a) => typeof a === "string")(_arg.value);
}
export function isAutomaticMechanicalDeburringMaterialUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetMaterialId" in _arg && ((a) => typeof a === "string")(_arg.sheetMaterialId);
}
export function isAutomaticMechanicalDeburringMaterial(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetMaterialId" in _arg && ((a) => typeof a === "string")(_arg.sheetMaterialId)
        && "automaticMechanicalDeburringMaterialId" in _arg && ((a) => typeof a === "string")(_arg.automaticMechanicalDeburringMaterialId);
}
export function isAutomaticMechanicalDeburringParametersUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "automaticMechanicalDeburringMaterialId" in _arg && ((a) => typeof a === "string")(_arg.automaticMechanicalDeburringMaterialId);
}
export function isAutomaticMechanicalDeburringParameters(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "automaticMechanicalDeburringMaterialId" in _arg && ((a) => typeof a === "string")(_arg.automaticMechanicalDeburringMaterialId)
        && "maxDimY" in _arg && ((a) => typeof a === "number")(_arg.maxDimY)
        && "unitTimeBase" in _arg && ((a) => typeof a === "number")(_arg.unitTimeBase)
        && "speed" in _arg && ((a) => typeof a === "number")(_arg.speed);
}
export function isDimensionConstraintsUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "processId" in _arg && ((a) => typeof a === "string")(_arg.processId);
}
export function isDimensionConstraints(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "processId" in _arg && ((a) => typeof a === "string")(_arg.processId)
        && "minX" in _arg && ((a) => typeof a === "number")(_arg.minX)
        && "minY" in _arg && ((a) => typeof a === "number")(_arg.minY)
        && "minZ" in _arg && ((a) => typeof a === "number")(_arg.minZ)
        && "maxX" in _arg && ((a) => typeof a === "number")(_arg.maxX)
        && "maxY" in _arg && ((a) => typeof a === "number")(_arg.maxY)
        && "maxZ" in _arg && ((a) => typeof a === "number")(_arg.maxZ);
}
export function isScrewThreadUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier);
}
export function isScrewThread(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier)
        && "name" in _arg && ((a) => typeof a === "string")(_arg.name)
        && "coreHoleDiameter" in _arg && ((a) => typeof a === "number")(_arg.coreHoleDiameter)
        && "minDepth" in _arg && ((a) => typeof a === "number")(_arg.minDepth)
        && "symmetricTolerance" in _arg && ((a) => typeof a === "number")(_arg.symmetricTolerance);
}
export function isTappingTimeParametersUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "processId" in _arg && ((a) => typeof a === "string")(_arg.processId)
        && "screwThreadId" in _arg && ((a) => typeof a === "string")(_arg.screwThreadId);
}
export function isTappingTimeParameters(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "processId" in _arg && ((a) => typeof a === "string")(_arg.processId)
        && "screwThreadId" in _arg && ((a) => typeof a === "string")(_arg.screwThreadId)
        && "unitTimePerMm" in _arg && ((a) => typeof a === "number")(_arg.unitTimePerMm);
}
export function isTubeMaterialUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier);
}
export function isTubeMaterial(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier)
        && "name" in _arg && ((a) => typeof a === "string")(_arg.name)
        && "description" in _arg && ((a) => typeof a === "string")(_arg.description);
}
export function isTubeMaterialDensityUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "tubeMaterialId" in _arg && ((a) => typeof a === "string")(_arg.tubeMaterialId);
}
export function isTubeMaterialDensity(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "tubeMaterialId" in _arg && ((a) => typeof a === "string")(_arg.tubeMaterialId)
        && "density" in _arg && ((a) => typeof a === "number")(_arg.density);
}
export function isTubeProfileUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier);
}
export function isTubeProfile(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier)
        && "name" in _arg && ((a) => typeof a === "string")(_arg.name)
        && "description" in _arg && ((a) => typeof a === "string")(_arg.description)
        && "geometryJson" in _arg && ((a) => typeof a === "string")(_arg.geometryJson);
}
export function isTubeSpecificationUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier);
}
export function isTubeSpecification(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier)
        && "name" in _arg && ((a) => typeof a === "string")(_arg.name)
        && "description" in _arg && ((a) => typeof a === "string")(_arg.description);
}
export function isTubeUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier);
}
export function isTube(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier)
        && "name" in _arg && ((a) => typeof a === "string")(_arg.name)
        && "tubeMaterialId" in _arg && ((a) => typeof a === "string")(_arg.tubeMaterialId)
        && "tubeProfileId" in _arg && ((a) => typeof a === "string")(_arg.tubeProfileId)
        && "tubeSpecificationId" in _arg && ((a) => typeof a === "string")(_arg.tubeSpecificationId)
        && "dimX" in _arg && ((a) => typeof a === "number")(_arg.dimX);
}
export function isUpperDieUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier);
}
export function isUpperDie(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier)
        && "name" in _arg && ((a) => typeof a === "string")(_arg.name)
        && "upperDieGroupId" in _arg && ((a) => typeof a === "string")(_arg.upperDieGroupId)
        && "description" in _arg && ((a) => typeof a === "string")(_arg.description);
}
export function isLowerDieUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier);
}
export function isLowerDie(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier)
        && "name" in _arg && ((a) => typeof a === "string")(_arg.name)
        && "lowerDieGroupId" in _arg && ((a) => typeof a === "string")(_arg.lowerDieGroupId)
        && "description" in _arg && ((a) => typeof a === "string")(_arg.description);
}
export function isUpperDieUnitUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "upperDieId" in _arg && ((a) => typeof a === "string")(_arg.upperDieId)
        && "dimX" in _arg && ((a) => typeof a === "number")(_arg.dimX);
}
export function isUpperDieUnit(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "upperDieId" in _arg && ((a) => typeof a === "string")(_arg.upperDieId)
        && "dimX" in _arg && ((a) => typeof a === "number")(_arg.dimX)
        && "multiplicity" in _arg && ((a) => typeof a === "number")(_arg.multiplicity);
}
export function isLowerDieUnitUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "lowerDieId" in _arg && ((a) => typeof a === "string")(_arg.lowerDieId)
        && "dimX" in _arg && ((a) => typeof a === "number")(_arg.dimX);
}
export function isLowerDieUnit(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "lowerDieId" in _arg && ((a) => typeof a === "string")(_arg.lowerDieId)
        && "dimX" in _arg && ((a) => typeof a === "number")(_arg.dimX)
        && "multiplicity" in _arg && ((a) => typeof a === "number")(_arg.multiplicity);
}
export function isProcessHandlingTimeUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "processId" in _arg && ((a) => typeof a === "string")(_arg.processId)
        && "mass" in _arg && ((a) => typeof a === "number")(_arg.mass);
}
export function isProcessHandlingTime(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "processId" in _arg && ((a) => typeof a === "string")(_arg.processId)
        && "mass" in _arg && ((a) => typeof a === "number")(_arg.mass)
        && "setupTimeDelta" in _arg && ((a) => typeof a === "number")(_arg.setupTimeDelta)
        && "unitTimeDelta" in _arg && ((a) => typeof a === "number")(_arg.unitTimeDelta);
}
export function isSheetStockUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetId" in _arg && ((a) => typeof a === "string")(_arg.sheetId);
}
export function isSheetStock(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetId" in _arg && ((a) => typeof a === "string")(_arg.sheetId)
        && "count" in _arg && ((a) => typeof a === "number")(_arg.count);
}
export function isProcessIdlePeriodUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "processId" in _arg && ((a) => typeof a === "string")(_arg.processId);
}
export function isProcessIdlePeriod(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "processId" in _arg && ((a) => typeof a === "string")(_arg.processId)
        && "time" in _arg && ((a) => typeof a === "number")(_arg.time);
}
export function isSheetMaterialScrapValueUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetMaterialId" in _arg && ((a) => typeof a === "string")(_arg.sheetMaterialId);
}
export function isSheetMaterialScrapValue(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetMaterialId" in _arg && ((a) => typeof a === "string")(_arg.sheetMaterialId)
        && "scrapValue" in _arg && ((a) => typeof a === "number")(_arg.scrapValue);
}
export function isSheetPriorityUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetId" in _arg && ((a) => typeof a === "string")(_arg.sheetId);
}
export function isSheetPriority(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "sheetId" in _arg && ((a) => typeof a === "string")(_arg.sheetId)
        && "priority" in _arg && ((a) => typeof a === "number")(_arg.priority);
}
export function isDieGroupPriorityUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "upperDieGroupId" in _arg && ((a) => typeof a === "string")(_arg.upperDieGroupId)
        && "lowerDieGroupId" in _arg && ((a) => typeof a === "string")(_arg.lowerDieGroupId)
        && "sheetBendingMaterialId" in _arg && ((a) => typeof a === "string")(_arg.sheetBendingMaterialId)
        && "sheetThickness" in _arg && ((a) => typeof a === "number")(_arg.sheetThickness);
}
export function isDieGroupPriority(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "upperDieGroupId" in _arg && ((a) => typeof a === "string")(_arg.upperDieGroupId)
        && "lowerDieGroupId" in _arg && ((a) => typeof a === "string")(_arg.lowerDieGroupId)
        && "sheetBendingMaterialId" in _arg && ((a) => typeof a === "string")(_arg.sheetBendingMaterialId)
        && "sheetThickness" in _arg && ((a) => typeof a === "number")(_arg.sheetThickness)
        && "priority" in _arg && ((a) => typeof a === "number")(_arg.priority);
}
export function isSheetCuttingMaterialUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier);
}
export function isSheetCuttingMaterial(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier)
        && "name" in _arg && ((a) => typeof a === "string")(_arg.name);
}
export function isSheetBendingMaterialUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier);
}
export function isSheetBendingMaterial(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier)
        && "name" in _arg && ((a) => typeof a === "string")(_arg.name);
}
export function isTubeCuttingProcessUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier);
}
export function isTubeCuttingProcess(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "identifier" in _arg && ((a) => typeof a === "string")(_arg.identifier)
        && "name" in _arg && ((a) => typeof a === "string")(_arg.name);
}
export function isTubeCuttingProcessMappingUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "processId" in _arg && ((a) => typeof a === "string")(_arg.processId)
        && "tubeMaterialId" in _arg && ((a) => typeof a === "string")(_arg.tubeMaterialId);
}
export function isTubeCuttingProcessMapping(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "processId" in _arg && ((a) => typeof a === "string")(_arg.processId)
        && "tubeMaterialId" in _arg && ((a) => typeof a === "string")(_arg.tubeMaterialId)
        && "tubeCuttingProcessId" in _arg && ((a) => typeof a === "string")(_arg.tubeCuttingProcessId);
}
export function isTubeCuttingSpeedUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "tubeCuttingProcessId" in _arg && ((a) => typeof a === "string")(_arg.tubeCuttingProcessId)
        && "thickness" in _arg && ((a) => typeof a === "number")(_arg.thickness);
}
export function isTubeCuttingSpeed(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "tubeCuttingProcessId" in _arg && ((a) => typeof a === "string")(_arg.tubeCuttingProcessId)
        && "thickness" in _arg && ((a) => typeof a === "number")(_arg.thickness)
        && "speed" in _arg && ((a) => typeof a === "number")(_arg.speed);
}
export function isTubeCuttingPierceTimeUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "tubeCuttingProcessId" in _arg && ((a) => typeof a === "string")(_arg.tubeCuttingProcessId)
        && "thickness" in _arg && ((a) => typeof a === "number")(_arg.thickness);
}
export function isTubeCuttingPierceTime(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "tubeCuttingProcessId" in _arg && ((a) => typeof a === "string")(_arg.tubeCuttingProcessId)
        && "thickness" in _arg && ((a) => typeof a === "number")(_arg.thickness)
        && "time" in _arg && ((a) => typeof a === "number")(_arg.time);
}
export function isTubePriceUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "tubeId" in _arg && ((a) => typeof a === "string")(_arg.tubeId);
}
export function isTubePrice(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "tubeId" in _arg && ((a) => typeof a === "string")(_arg.tubeId)
        && "pricePerTube" in _arg && ((a) => typeof a === "number")(_arg.pricePerTube);
}
export function isTubeStockUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "tubeId" in _arg && ((a) => typeof a === "string")(_arg.tubeId);
}
export function isTubeStock(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "tubeId" in _arg && ((a) => typeof a === "string")(_arg.tubeId)
        && "count" in _arg && ((a) => typeof a === "number")(_arg.count);
}
export function isTubeMaterialScrapValueUniqueMembers(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "tubeMaterialId" in _arg && ((a) => typeof a === "string")(_arg.tubeMaterialId);
}
export function isTubeMaterialScrapValue(_arg) {
    return (typeof _arg === "object" && _arg !== null)
        && "tubeMaterialId" in _arg && ((a) => typeof a === "string")(_arg.tubeMaterialId)
        && "scrapValue" in _arg && ((a) => typeof a === "number")(_arg.scrapValue);
}
export function isAnyTable(_arg) {
    return typeof _arg === "object" && _arg !== null && isTableType(_arg.type) && ((a) => (((a) => Array.isArray(a) && a.find((e) => !isSheetMaterial(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isSheetMaterialDensity(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isSheetCuttingMaterialMapping(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isSheetBendingMaterialMapping(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isBendTime(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isBendTimeParameters(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isBendRateParameters(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isBendLineConstraint(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isLaserSheetCuttingGas(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isLaserSheetCuttingSpeed(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isLaserSheetCuttingPierceTime(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isLaserSheetCuttingRate(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isLaserSheetCuttingMinArea(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isLaserSheetCuttingMaxThickness(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isPackaging(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isTransportationCosts(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isSurcharge(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isProcess(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isProcessRate(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isProcessSetupTimeFallback(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isProcessUnitTimeFallback(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isSheet(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isSheetModulus(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isSheetPrice(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isUpperDieGroup(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isLowerDieGroup(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isBendDeduction(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isSetting(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isAutomaticMechanicalDeburringMaterial(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isAutomaticMechanicalDeburringParameters(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isDimensionConstraints(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isScrewThread(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isTappingTimeParameters(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isTubeMaterial(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isTubeMaterialDensity(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isTubeProfile(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isTubeSpecification(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isTube(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isUpperDie(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isLowerDie(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isUpperDieUnit(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isLowerDieUnit(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isProcessHandlingTime(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isSheetStock(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isProcessIdlePeriod(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isSheetMaterialScrapValue(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isSheetPriority(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isDieGroupPriority(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isSheetCuttingMaterial(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isSheetBendingMaterial(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isTubeCuttingProcess(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isTubeCuttingProcessMapping(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isTubeCuttingSpeed(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isTubeCuttingPierceTime(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isTubePrice(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isTubeStock(e)) === undefined)(a) || ((a) => Array.isArray(a) && a.find((e) => !isTubeMaterialScrapValue(e)) === undefined)(a)))(_arg.content);
}
export function isReferredEntryMissingTableError(_arg) {
    return typeof _arg === "object" && _arg !== null && "affectedRowType" in _arg && isTableType(_arg.affectedRowType)
        && "affectedRowIndex" in _arg && ((a) => typeof a === "number")(_arg.affectedRowIndex)
        && "affectedColumnIndex" in _arg && ((a) => typeof a === "number")(_arg.affectedColumnIndex)
        && "relatedRowType" in _arg && isTableType(_arg.relatedRowType)
        && "relatedColumnIndex" in _arg && ((a) => typeof a === "number")(_arg.relatedColumnIndex)
        && "referredId" in _arg && ((a) => typeof a === "string")(_arg.referredId);
}
export function isReferringEntryMissingTableError(_arg) {
    return typeof _arg === "object" && _arg !== null && "affectedRowType" in _arg && isTableType(_arg.affectedRowType)
        && "affectedColumnIndex" in _arg && ((a) => typeof a === "number")(_arg.affectedColumnIndex)
        && "relatedRowType" in _arg && isTableType(_arg.relatedRowType)
        && "relatedRowIndex" in _arg && ((a) => typeof a === "number")(_arg.relatedRowIndex)
        && "relatedColumnIndex" in _arg && ((a) => typeof a === "number")(_arg.relatedColumnIndex);
}
export function isInvalidValueTableError(_arg) {
    return typeof _arg === "object" && _arg !== null && "affectedRowType" in _arg && isTableType(_arg.affectedRowType)
        && "affectedRowIndex" in _arg && ((a) => typeof a === "number")(_arg.affectedRowIndex)
        && "affectedColumnIndex" in _arg && ((a) => typeof a === "number")(_arg.affectedColumnIndex);
}
export function isUniqueMemberCollisionTableError(_arg) {
    return typeof _arg === "object" && _arg !== null && "affectedRowType" in _arg && isTableType(_arg.affectedRowType)
        && "affectedRowIndex" in _arg && ((a) => typeof a === "number")(_arg.affectedRowIndex)
        && "affectedColumnIndex" in _arg && ((a) => typeof a === "number")(_arg.affectedColumnIndex)
        && "relatedRowIndex" in _arg && ((a) => typeof a === "number")(_arg.relatedRowIndex);
}
export function isTableError(_arg) {
    return typeof _arg === "object" && _arg !== null && isTableErrorType(_arg.type) && ((a) => (isReferringEntryMissingTableError(a) || isReferredEntryMissingTableError(a) || isInvalidValueTableError(a) || isUniqueMemberCollisionTableError(a)))(_arg.content);
}
export function isHttpReply(_arg) {
    return typeof _arg === "object" && _arg !== null && "errorCode" in _arg && ((a) => typeof a === "number")(_arg.errorCode)
        && "data" in _arg && ((a) => a instanceof ArrayBuffer)(_arg.data);
}
export function isLineSegment(_arg) {
    return typeof _arg === "object" && _arg !== null && "from" in _arg && isPoint2(_arg.from)
        && "to" in _arg && isPoint2(_arg.to);
}
export function isArcSegment(_arg) {
    return typeof _arg === "object" && _arg !== null && "from" in _arg && isPoint2(_arg.from)
        && "to" in _arg && isPoint2(_arg.to)
        && "center" in _arg && isPoint2(_arg.center)
        && "ccw" in _arg && ((a) => typeof a === "boolean")(_arg.ccw);
}
export function isSegment(_arg) {
    return typeof _arg === "object" && _arg !== null && isSegmentType(_arg.type) && ((a) => (isLineSegment(a) || isArcSegment(a)))(_arg.content);
}
export function isSceneStyle(_arg) {
    return typeof _arg === "object" && _arg !== null && !("strokeWidth" in _arg) || ((a) => (a === undefined || ((a) => typeof a === "number")(a)))(_arg.strokeWidth)
        && !("strokeColor" in _arg) || ((a) => (a === undefined || isColor(a)))(_arg.strokeColor)
        && !("fillColor" in _arg) || ((a) => (a === undefined || isVector4(a)))(_arg.fillColor)
        && !("strokeStyle" in _arg) || ((a) => (a === undefined || isStrokeStyle(a)))(_arg.strokeStyle)
        && !("zValue" in _arg) || ((a) => (a === undefined || ((a) => typeof a === "number")(a)))(_arg.zValue);
}
export function isProgramVersion(_arg) {
    return typeof _arg === "object" && _arg !== null && "major" in _arg && ((a) => typeof a === "number")(_arg.major)
        && "minor" in _arg && ((a) => typeof a === "number")(_arg.minor)
        && "patch" in _arg && ((a) => typeof a === "number")(_arg.patch);
}
export function isGeometryEntityDescriptorContentEdge(_arg) {
    return typeof _arg === "object" && _arg !== null && "value" in _arg && ((a) => typeof a === "number")(_arg.value);
}
export function isGeometryEntityDescriptorContentFace(_arg) {
    return typeof _arg === "object" && _arg !== null && "value" in _arg && ((a) => typeof a === "number")(_arg.value);
}
export function isGeometryEntityDescriptor(_arg) {
    return typeof _arg === "object" && _arg !== null && isGeometryEntityType(_arg.type) && ((a) => (isGeometryEntityDescriptorContentEdge(a) || isGeometryEntityDescriptorContentFace(a)))(_arg.content);
}
export function isGeometryEntity(_arg) {
    return typeof _arg === "object" && _arg !== null && "assemblyPath" in _arg && isAssemblyPath(_arg.assemblyPath)
        && "descriptor" in _arg && isGeometryEntityDescriptor(_arg.descriptor);
}
export function isCamCommandSetColor(_arg) {
    return typeof _arg === "object" && _arg !== null && "entities" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isGeometryEntity(e)) === undefined)(_arg.entities)
        && "color" in _arg && isVector3(_arg.color);
}
export function isCamCommand(_arg) {
    return typeof _arg === "object" && _arg !== null && isCamCommandType(_arg.type) && ((a) => (isCamCommandSetColor(a)))(_arg.content);
}
export function isCamNestorInputPart(_arg) {
    return typeof _arg === "object" && _arg !== null && "iop" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.iop)
        && "minCount" in _arg && ((a) => typeof a === "number")(_arg.minCount)
        && "maxCount" in _arg && ((a) => typeof a === "number")(_arg.maxCount)
        && "fixedRotations" in _arg && ((a) => Array.isArray(a) && a.find((e) => !((a) => typeof a === "number")(e)) === undefined)(_arg.fixedRotations);
}
export function isCamNestorInput(_arg) {
    return typeof _arg === "object" && _arg !== null && "parts" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isCamNestorInputPart(e)) === undefined)(_arg.parts)
        && "targetBoundary" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.targetBoundary)
        && "nestingDistance" in _arg && ((a) => typeof a === "number")(_arg.nestingDistance);
}
export function isCamNestorConfig(_arg) {
    return typeof _arg === "object" && _arg !== null && "timeout" in _arg && ((a) => typeof a === "number")(_arg.timeout)
        && "numRelevantNestings" in _arg && ((a) => typeof a === "number")(_arg.numRelevantNestings);
}
export function isCamWorkStepUpdateInputSheet(_arg) {
    return typeof _arg === "object" && _arg !== null && "nestorInput" in _arg && isCamNestorInput(_arg.nestorInput)
        && "nestorConfig" in _arg && isCamNestorConfig(_arg.nestorConfig);
}
export function isCamWorkStepUpdateInputTube(_arg) {
    return typeof _arg === "object" && _arg !== null && "length" in _arg && ((a) => typeof a === "number")(_arg.length)
        && "multiplicity" in _arg && ((a) => typeof a === "number")(_arg.multiplicity)
        && "nestingDistance" in _arg && ((a) => typeof a === "number")(_arg.nestingDistance);
}
export function isAssemblyPath(_arg) {
    return typeof _arg === "object" && _arg !== null && "indices" in _arg && ((a) => Array.isArray(a) && a.find((e) => !((a) => typeof a === "number")(e)) === undefined)(_arg.indices);
}
export function isLayeredExtraData(_arg) {
    return typeof _arg === "object" && _arg !== null && "thickness" in _arg && ((a) => typeof a === "number")(_arg.thickness)
        && "name" in _arg && ((a) => typeof a === "string")(_arg.name)
        && "material" in _arg && ((a) => typeof a === "string")(_arg.material);
}
export function isRenderSceneSettings(_arg) {
    return typeof _arg === "object" && _arg !== null && !("viewPort" in _arg) || ((a) => (a === undefined || isBox2(a)))(_arg.viewPort);
}
export function isTwoDimImportResultPartInvalid(_arg) {
    return typeof _arg === "object" && _arg !== null && !("problematicPoint" in _arg) || ((a) => (a === undefined || isPoint2(a)))(_arg.problematicPoint);
}
export function isTwoDimImportResultEngravingInvalid(_arg) {
    return typeof _arg === "object" && _arg !== null && "problematicPoint" in _arg && isPoint2(_arg.problematicPoint);
}
export function isTwoDimImportResultSuccess(_arg) {
    return typeof _arg === "object" && _arg !== null && "twoDimRep" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.twoDimRep);
}
export function isTwoDimImportResult(_arg) {
    return typeof _arg === "object" && _arg !== null && isTwoDimImportResultType(_arg.type) && ((a) => (isTwoDimImportResultPartInvalid(a) || isTwoDimImportResultEngravingInvalid(a) || isTwoDimImportResultSuccess(a)))(_arg.content);
}
export function isPrivateManufacturingStateEntry(_arg) {
    return typeof _arg === "object" && _arg !== null && "level" in _arg && ((a) => typeof a === "string")(_arg.level)
        && "message" in _arg && ((a) => typeof a === "string")(_arg.message);
}
export function isPrivateManufacturingStateResourceEntry(_arg) {
    return typeof _arg === "object" && _arg !== null && "nodeId" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.nodeId)
        && "actualState" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isPrivateManufacturingStateEntry(e)) === undefined)(_arg.actualState)
        && "virtualState" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isPrivateManufacturingStateEntry(e)) === undefined)(_arg.virtualState);
}
export function isPrivateNodeRepresentation(_arg) {
    return typeof _arg === "object" && _arg !== null && "nodeId" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.nodeId)
        && "rootId" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.rootId)
        && "sourceNodeIds" in _arg && ((a) => Array.isArray(a) && a.find((e) => !((a) => (typeof a === "object" && a !== null))(e)) === undefined)(_arg.sourceNodeIds)
        && "targetNodeIds" in _arg && ((a) => Array.isArray(a) && a.find((e) => !((a) => (typeof a === "object" && a !== null))(e)) === undefined)(_arg.targetNodeIds)
        && "workStepType" in _arg && isWorkStepType(_arg.workStepType)
        && "processType" in _arg && isProcessType(_arg.processType)
        && "processId" in _arg && ((a) => typeof a === "string")(_arg.processId)
        && "processName" in _arg && ((a) => typeof a === "string")(_arg.processName);
}
export function isPrivateArticleRepresentation(_arg) {
    return typeof _arg === "object" && _arg !== null && "name" in _arg && ((a) => typeof a === "string")(_arg.name)
        && "externalPartNumber" in _arg && ((a) => typeof a === "string")(_arg.externalPartNumber)
        && "externalDrawingNumber" in _arg && ((a) => typeof a === "string")(_arg.externalDrawingNumber)
        && "externalRevisionNumber" in _arg && ((a) => typeof a === "string")(_arg.externalRevisionNumber)
        && "comment" in _arg && ((a) => typeof a === "string")(_arg.comment)
        && "multiplicity" in _arg && ((a) => typeof a === "number")(_arg.multiplicity)
        && "nodeId" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.nodeId)
        && "rootId" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.rootId)
        && "nodeIds" in _arg && ((a) => Array.isArray(a) && a.find((e) => !((a) => (typeof a === "object" && a !== null))(e)) === undefined)(_arg.nodeIds);
}
export function isPrivateAssemblyResourceEntry(_arg) {
    return typeof _arg === "object" && _arg !== null && "nodeId" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.nodeId)
        && "assembly" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.assembly);
}
export function isPrivateBinaryResourceEntry(_arg) {
    return typeof _arg === "object" && _arg !== null && "nodeId" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.nodeId)
        && "data" in _arg && ((a) => a instanceof ArrayBuffer)(_arg.data);
}
export function isPrivateSceneResourceEntry(_arg) {
    return typeof _arg === "object" && _arg !== null && "nodeId" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.nodeId)
        && "data" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.data);
}
export function isPrivateScenesResourceEntry(_arg) {
    return typeof _arg === "object" && _arg !== null && "nodeId" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.nodeId)
        && "data" in _arg && ((a) => Array.isArray(a) && a.find((e) => !((a) => (typeof a === "object" && a !== null))(e)) === undefined)(_arg.data);
}
export function isPrivateNodeTextResourceEntry(_arg) {
    return typeof _arg === "object" && _arg !== null && "nodeId" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.nodeId)
        && "brief" in _arg && ((a) => typeof a === "string")(_arg.brief)
        && "details" in _arg && ((a) => typeof a === "string")(_arg.details)
        && "toolTip" in _arg && ((a) => typeof a === "string")(_arg.toolTip);
}
export function isPrivateArticleTextResourceEntry(_arg) {
    return typeof _arg === "object" && _arg !== null && "nodeId" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.nodeId)
        && "details" in _arg && ((a) => typeof a === "string")(_arg.details);
}
export function isPrivateArticleSignatureNodeResourceEntry(_arg) {
    return typeof _arg === "object" && _arg !== null && "nodeId" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.nodeId)
        && "material" in _arg && ((a) => typeof a === "string")(_arg.material)
        && !("mass" in _arg) || ((a) => (a === undefined || ((a) => typeof a === "number")(a)))(_arg.mass)
        && !("sheetThickness" in _arg) || ((a) => (a === undefined || ((a) => typeof a === "number")(a)))(_arg.sheetThickness);
}
export function isPrivateSourceMultEntry(_arg) {
    return typeof _arg === "object" && _arg !== null && "sourceArticleNodeId" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.sourceArticleNodeId)
        && "targetArticleNodeId" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.targetArticleNodeId)
        && "multiplicity" in _arg && ((a) => typeof a === "number")(_arg.multiplicity);
}
export function isPrivateArticleCalcDataResourceEntry(_arg) {
    return typeof _arg === "object" && _arg !== null && "nodeId" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.nodeId)
        && !("approxSemimanufacturedShare" in _arg) || ((a) => (a === undefined || ((a) => typeof a === "number")(a)))(_arg.approxSemimanufacturedShare)
        && !("manufacturingPriceExclSurcharges" in _arg) || ((a) => (a === undefined || ((a) => typeof a === "number")(a)))(_arg.manufacturingPriceExclSurcharges)
        && !("manufacturingPriceInclSurcharges" in _arg) || ((a) => (a === undefined || ((a) => typeof a === "number")(a)))(_arg.manufacturingPriceInclSurcharges)
        && !("recursiveManufacturingPriceExclSurcharges" in _arg) || ((a) => (a === undefined || ((a) => typeof a === "number")(a)))(_arg.recursiveManufacturingPriceExclSurcharges)
        && !("recursiveManufacturingPriceInclSurcharges" in _arg) || ((a) => (a === undefined || ((a) => typeof a === "number")(a)))(_arg.recursiveManufacturingPriceInclSurcharges)
        && !("sellingPrice" in _arg) || ((a) => (a === undefined || ((a) => typeof a === "number")(a)))(_arg.sellingPrice)
        && !("recursiveSellingPrice" in _arg) || ((a) => (a === undefined || ((a) => typeof a === "number")(a)))(_arg.recursiveSellingPrice);
}
export function isPrivateNodeCalcDataResourceEntry(_arg) {
    return typeof _arg === "object" && _arg !== null && "nodeId" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.nodeId)
        && !("materialCosts" in _arg) || ((a) => (a === undefined || ((a) => typeof a === "number")(a)))(_arg.materialCosts)
        && !("setupTime" in _arg) || ((a) => (a === undefined || ((a) => typeof a === "number")(a)))(_arg.setupTime)
        && !("unitTime" in _arg) || ((a) => (a === undefined || ((a) => typeof a === "number")(a)))(_arg.unitTime)
        && !("manufacturingPriceExclSurcharges" in _arg) || ((a) => (a === undefined || ((a) => typeof a === "number")(a)))(_arg.manufacturingPriceExclSurcharges)
        && !("manufacturingPriceInclSurcharges" in _arg) || ((a) => (a === undefined || ((a) => typeof a === "number")(a)))(_arg.manufacturingPriceInclSurcharges)
        && !("sellingPrice" in _arg) || ((a) => (a === undefined || ((a) => typeof a === "number")(a)))(_arg.sellingPrice);
}
export function isPrivateProblematicGeometryResourceEntry(_arg) {
    return typeof _arg === "object" && _arg !== null && "nodeId" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.nodeId)
        && "hasProblematicGeometries" in _arg && ((a) => typeof a === "boolean")(_arg.hasProblematicGeometries);
}
export function isPrivateForceSheetMetalPartResourceEntry(_arg) {
    return typeof _arg === "object" && _arg !== null && "nodeId" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.nodeId)
        && "canForceFuture" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.canForceFuture);
}
export function isPrivateResources(_arg) {
    return typeof _arg === "object" && _arg !== null && "pngs" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isPrivateBinaryResourceEntry(e)) === undefined)(_arg.pngs)
        && "inputAssemblies" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isPrivateAssemblyResourceEntry(e)) === undefined)(_arg.inputAssemblies)
        && "outputAssemblies" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isPrivateAssemblyResourceEntry(e)) === undefined)(_arg.outputAssemblies)
        && "defaultScenes" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isPrivateSceneResourceEntry(e)) === undefined)(_arg.defaultScenes)
        && "bendZoneScenes" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isPrivateSceneResourceEntry(e)) === undefined)(_arg.bendZoneScenes)
        && "lowerDieAffectZoneScenes" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isPrivateSceneResourceEntry(e)) === undefined)(_arg.lowerDieAffectZoneScenes)
        && "technicalDrawingScenes" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isPrivateScenesResourceEntry(e)) === undefined)(_arg.technicalDrawingScenes)
        && "tubeOutlineScenes" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isPrivateSceneResourceEntry(e)) === undefined)(_arg.tubeOutlineScenes)
        && "manufacturingStates" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isPrivateManufacturingStateResourceEntry(e)) === undefined)(_arg.manufacturingStates)
        && "nodeTexts" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isPrivateNodeTextResourceEntry(e)) === undefined)(_arg.nodeTexts)
        && "articleTexts" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isPrivateArticleTextResourceEntry(e)) === undefined)(_arg.articleTexts)
        && "articleCalcData" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isPrivateArticleCalcDataResourceEntry(e)) === undefined)(_arg.articleCalcData)
        && "articleSignatureNodeData" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isPrivateArticleSignatureNodeResourceEntry(e)) === undefined)(_arg.articleSignatureNodeData)
        && "nodeCalcData" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isPrivateNodeCalcDataResourceEntry(e)) === undefined)(_arg.nodeCalcData)
        && "nodeProblematicGeometryData" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isPrivateProblematicGeometryResourceEntry(e)) === undefined)(_arg.nodeProblematicGeometryData)
        && "nodeForceSheetMetalPartData" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isPrivateForceSheetMetalPartResourceEntry(e)) === undefined)(_arg.nodeForceSheetMetalPartData);
}
export function isPrivateGraphData(_arg) {
    return typeof _arg === "object" && _arg !== null && "projectName" in _arg && ((a) => typeof a === "string")(_arg.projectName);
}
export function isPrivateGuiDataGraphRep(_arg) {
    return typeof _arg === "object" && _arg !== null && "nodes" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isPrivateNodeRepresentation(e)) === undefined)(_arg.nodes)
        && "articles" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isPrivateArticleRepresentation(e)) === undefined)(_arg.articles)
        && "resources" in _arg && isPrivateResources(_arg.resources)
        && "data" in _arg && isPrivateGraphData(_arg.data)
        && "sourceMults" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isPrivateSourceMultEntry(e)) === undefined)(_arg.sourceMults);
}
export function isPrivateGuiData(_arg) {
    return typeof _arg === "object" && _arg !== null && isPrivateGuiDataType(_arg.type) && ((a) => (isPrivateGuiDataGraphRep(a)))(_arg.content);
}
export function isPrivateSheetTablesEditorInitData(_arg) {
    return typeof _arg === "object" && _arg !== null && "sheetMaterials" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isSheetMaterial(e)) === undefined)(_arg.sheetMaterials)
        && "sheetMaterialDensities" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isSheetMaterialDensity(e)) === undefined)(_arg.sheetMaterialDensities)
        && "sheetMaterialScrapValues" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isSheetMaterialScrapValue(e)) === undefined)(_arg.sheetMaterialScrapValues)
        && "sheets" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isSheet(e)) === undefined)(_arg.sheets)
        && "sheetPrices" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isSheetPrice(e)) === undefined)(_arg.sheetPrices)
        && "sheetStocks" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isSheetStock(e)) === undefined)(_arg.sheetStocks)
        && "sheetModuli" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isSheetModulus(e)) === undefined)(_arg.sheetModuli)
        && "sheetPriorities" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isSheetPriority(e)) === undefined)(_arg.sheetPriorities)
        && "sheetCuttingMaterials" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isSheetCuttingMaterial(e)) === undefined)(_arg.sheetCuttingMaterials)
        && "sheetBendingMaterials" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isSheetBendingMaterial(e)) === undefined)(_arg.sheetBendingMaterials)
        && "sheetCuttingMaterialMappings" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isSheetCuttingMaterialMapping(e)) === undefined)(_arg.sheetCuttingMaterialMappings)
        && "sheetBendingMaterialMappings" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isSheetBendingMaterialMapping(e)) === undefined)(_arg.sheetBendingMaterialMappings);
}
export function isPrivateTubeTablesEditorInitData(_arg) {
    return typeof _arg === "object" && _arg !== null && "tubeMaterials" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isTubeMaterial(e)) === undefined)(_arg.tubeMaterials)
        && "tubeMaterialDensities" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isTubeMaterialDensity(e)) === undefined)(_arg.tubeMaterialDensities)
        && "tubeProfiles" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isTubeProfile(e)) === undefined)(_arg.tubeProfiles)
        && "tubeSpecifications" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isTubeSpecification(e)) === undefined)(_arg.tubeSpecifications)
        && "tubes" in _arg && ((a) => Array.isArray(a) && a.find((e) => !isTube(e)) === undefined)(_arg.tubes);
}
export function isNest3Part(_arg) {
    return typeof _arg === "object" && _arg !== null && "assembly" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.assembly)
        && "multiplicity" in _arg && ((a) => typeof a === "number")(_arg.multiplicity)
        && "mass" in _arg && ((a) => typeof a === "number")(_arg.mass)
        && !("prismBodyShadow" in _arg) || ((a) => (a === undefined || ((a) => (typeof a === "object" && a !== null))(a)))(_arg.prismBodyShadow)
        && !("prismBodyCamera" in _arg) || ((a) => (a === undefined || isCamera3(a)))(_arg.prismBodyCamera);
}
export function isNest3InputBin(_arg) {
    return typeof _arg === "object" && _arg !== null && "box" in _arg && isBox3(_arg.box)
        && "maxWeight" in _arg && ((a) => typeof a === "number")(_arg.maxWeight);
}
export function isNest3ResultBox(_arg) {
    return typeof _arg === "object" && _arg !== null && "assembly" in _arg && ((a) => (typeof a === "object" && a !== null))(_arg.assembly)
        && "weight" in _arg && ((a) => typeof a === "number")(_arg.weight);
}
export function isBendDieAffectDistanceEntry(_arg) {
    return typeof _arg === "object" && _arg !== null && "bendDescriptor" in _arg && ((a) => typeof a === "number")(_arg.bendDescriptor)
        && "affectDistance" in _arg && ((a) => typeof a === "number")(_arg.affectDistance);
}
export function isLstCreationParameters(_arg) {
    return typeof _arg === "object" && _arg !== null && "programName" in _arg && ((a) => typeof a === "string")(_arg.programName)
        && "lttIdentifier" in _arg && ((a) => typeof a === "string")(_arg.lttIdentifier)
        && "sheetThickness" in _arg && ((a) => typeof a === "number")(_arg.sheetThickness)
        && "sheetMaterial" in _arg && ((a) => typeof a === "string")(_arg.sheetMaterial)
        && "measureSheet" in _arg && ((a) => typeof a === "boolean")(_arg.measureSheet)
        && "loadingSystem" in _arg && isTrumpfLoadingSystem(_arg.loadingSystem)
        && "evaporate" in _arg && isLstEvaporateMode(_arg.evaporate)
        && "measuringCorner" in _arg && isSheetCorner(_arg.measuringCorner)
        && "sheetMetalStop" in _arg && isSheetCorner(_arg.sheetMetalStop);
}
export const SheetMaterialUniqueMembersKey = [
    "identifier",
];
export const SheetMaterialDensityUniqueMembersKey = [
    "sheetMaterialId",
];
export const SheetCuttingMaterialMappingUniqueMembersKey = [
    "sheetMaterialId",
];
export const SheetBendingMaterialMappingUniqueMembersKey = [
    "sheetMaterialId",
];
export const BendTimeUniqueMembersKey = [
    "mass",
];
export const BendTimeParametersUniqueMembersKey = [
    "sheetBendingMaterialId",
    "thickness",
    "bendLineNetLength",
];
export const BendRateParametersUniqueMembersKey = [
    "sheetBendingMaterialId",
    "thickness",
    "bendLineNetLength",
];
export const BendLineConstraintUniqueMembersKey = [
    "sheetBendingMaterialId",
    "thickness",
];
export const LaserSheetCuttingGasUniqueMembersKey = [
    "identifier",
];
export const LaserSheetCuttingSpeedUniqueMembersKey = [
    "sheetCuttingMaterialId",
    "laserSheetCuttingGasId",
    "thickness",
];
export const LaserSheetCuttingPierceTimeUniqueMembersKey = [
    "sheetCuttingMaterialId",
    "laserSheetCuttingGasId",
    "thickness",
];
export const LaserSheetCuttingRateUniqueMembersKey = [
    "sheetCuttingMaterialId",
    "laserSheetCuttingGasId",
];
export const LaserSheetCuttingMinAreaUniqueMembersKey = [
    "sheetCuttingMaterialId",
    "laserSheetCuttingGasId",
    "thickness",
];
export const LaserSheetCuttingMaxThicknessUniqueMembersKey = [
    "sheetCuttingMaterialId",
    "laserSheetCuttingGasId",
];
export const PackagingUniqueMembersKey = [
    "identifier",
];
export const TransportationCostsUniqueMembersKey = [
    "identifier",
];
export const SurchargeUniqueMembersKey = [
    "name",
    "type",
    "value",
];
export const ProcessUniqueMembersKey = [
    "identifier",
];
export const ProcessRateUniqueMembersKey = [
    "processId",
];
export const ProcessSetupTimeFallbackUniqueMembersKey = [
    "processId",
];
export const ProcessUnitTimeFallbackUniqueMembersKey = [
    "processId",
];
export const SheetUniqueMembersKey = [
    "identifier",
];
export const SheetModulusUniqueMembersKey = [
    "sheetId",
];
export const SheetPriceUniqueMembersKey = [
    "sheetId",
];
export const UpperDieGroupUniqueMembersKey = [
    "identifier",
];
export const LowerDieGroupUniqueMembersKey = [
    "identifier",
];
export const BendDeductionUniqueMembersKey = [
    "sheetBendingMaterialId",
    "upperDieGroupId",
    "lowerDieGroupId",
    "thickness",
    "bendAngle",
];
export const SettingUniqueMembersKey = [
    "key",
];
export const AutomaticMechanicalDeburringMaterialUniqueMembersKey = [
    "sheetMaterialId",
];
export const AutomaticMechanicalDeburringParametersUniqueMembersKey = [
    "automaticMechanicalDeburringMaterialId",
];
export const DimensionConstraintsUniqueMembersKey = [
    "processId",
];
export const ScrewThreadUniqueMembersKey = [
    "identifier",
];
export const TappingTimeParametersUniqueMembersKey = [
    "processId",
    "screwThreadId",
];
export const TubeMaterialUniqueMembersKey = [
    "identifier",
];
export const TubeMaterialDensityUniqueMembersKey = [
    "tubeMaterialId",
];
export const TubeProfileUniqueMembersKey = [
    "identifier",
];
export const TubeSpecificationUniqueMembersKey = [
    "identifier",
];
export const TubeUniqueMembersKey = [
    "identifier",
];
export const UpperDieUniqueMembersKey = [
    "identifier",
];
export const LowerDieUniqueMembersKey = [
    "identifier",
];
export const UpperDieUnitUniqueMembersKey = [
    "upperDieId",
    "dimX",
];
export const LowerDieUnitUniqueMembersKey = [
    "lowerDieId",
    "dimX",
];
export const ProcessHandlingTimeUniqueMembersKey = [
    "processId",
    "mass",
];
export const SheetStockUniqueMembersKey = [
    "sheetId",
];
export const ProcessIdlePeriodUniqueMembersKey = [
    "processId",
];
export const SheetMaterialScrapValueUniqueMembersKey = [
    "sheetMaterialId",
];
export const SheetPriorityUniqueMembersKey = [
    "sheetId",
];
export const DieGroupPriorityUniqueMembersKey = [
    "upperDieGroupId",
    "lowerDieGroupId",
    "sheetBendingMaterialId",
    "sheetThickness",
];
export const SheetCuttingMaterialUniqueMembersKey = [
    "identifier",
];
export const SheetBendingMaterialUniqueMembersKey = [
    "identifier",
];
export const TubeCuttingProcessUniqueMembersKey = [
    "identifier",
];
export const TubeCuttingProcessMappingUniqueMembersKey = [
    "processId",
    "tubeMaterialId",
];
export const TubeCuttingSpeedUniqueMembersKey = [
    "tubeCuttingProcessId",
    "thickness",
];
export const TubeCuttingPierceTimeUniqueMembersKey = [
    "tubeCuttingProcessId",
    "thickness",
];
export const TubePriceUniqueMembersKey = [
    "tubeId",
];
export const TubeStockUniqueMembersKey = [
    "tubeId",
];
export const TubeMaterialScrapValueUniqueMembersKey = [
    "tubeMaterialId",
];
export const uniqueMembersKeyMap = {
    sheetMaterial: [...SheetMaterialUniqueMembersKey],
    sheetMaterialDensity: [...SheetMaterialDensityUniqueMembersKey],
    sheetCuttingMaterialMapping: [...SheetCuttingMaterialMappingUniqueMembersKey],
    sheetBendingMaterialMapping: [...SheetBendingMaterialMappingUniqueMembersKey],
    bendTime: [...BendTimeUniqueMembersKey],
    bendTimeParameters: [...BendTimeParametersUniqueMembersKey],
    bendRateParameters: [...BendRateParametersUniqueMembersKey],
    bendLineConstraint: [...BendLineConstraintUniqueMembersKey],
    laserSheetCuttingGas: [...LaserSheetCuttingGasUniqueMembersKey],
    laserSheetCuttingSpeed: [...LaserSheetCuttingSpeedUniqueMembersKey],
    laserSheetCuttingPierceTime: [...LaserSheetCuttingPierceTimeUniqueMembersKey],
    laserSheetCuttingRate: [...LaserSheetCuttingRateUniqueMembersKey],
    laserSheetCuttingMinArea: [...LaserSheetCuttingMinAreaUniqueMembersKey],
    laserSheetCuttingMaxThickness: [...LaserSheetCuttingMaxThicknessUniqueMembersKey],
    packaging: [...PackagingUniqueMembersKey],
    transportationCosts: [...TransportationCostsUniqueMembersKey],
    surcharge: [...SurchargeUniqueMembersKey],
    process: [...ProcessUniqueMembersKey],
    processRate: [...ProcessRateUniqueMembersKey],
    processSetupTimeFallback: [...ProcessSetupTimeFallbackUniqueMembersKey],
    processUnitTimeFallback: [...ProcessUnitTimeFallbackUniqueMembersKey],
    sheet: [...SheetUniqueMembersKey],
    sheetModulus: [...SheetModulusUniqueMembersKey],
    sheetPrice: [...SheetPriceUniqueMembersKey],
    upperDieGroup: [...UpperDieGroupUniqueMembersKey],
    lowerDieGroup: [...LowerDieGroupUniqueMembersKey],
    bendDeduction: [...BendDeductionUniqueMembersKey],
    setting: [...SettingUniqueMembersKey],
    automaticMechanicalDeburringMaterial: [...AutomaticMechanicalDeburringMaterialUniqueMembersKey],
    automaticMechanicalDeburringParameters: [...AutomaticMechanicalDeburringParametersUniqueMembersKey],
    dimensionConstraints: [...DimensionConstraintsUniqueMembersKey],
    screwThread: [...ScrewThreadUniqueMembersKey],
    tappingTimeParameters: [...TappingTimeParametersUniqueMembersKey],
    tubeMaterial: [...TubeMaterialUniqueMembersKey],
    tubeMaterialDensity: [...TubeMaterialDensityUniqueMembersKey],
    tubeProfile: [...TubeProfileUniqueMembersKey],
    tubeSpecification: [...TubeSpecificationUniqueMembersKey],
    tube: [...TubeUniqueMembersKey],
    upperDie: [...UpperDieUniqueMembersKey],
    lowerDie: [...LowerDieUniqueMembersKey],
    upperDieUnit: [...UpperDieUnitUniqueMembersKey],
    lowerDieUnit: [...LowerDieUnitUniqueMembersKey],
    processHandlingTime: [...ProcessHandlingTimeUniqueMembersKey],
    sheetStock: [...SheetStockUniqueMembersKey],
    processIdlePeriod: [...ProcessIdlePeriodUniqueMembersKey],
    sheetMaterialScrapValue: [...SheetMaterialScrapValueUniqueMembersKey],
    sheetPriority: [...SheetPriorityUniqueMembersKey],
    dieGroupPriority: [...DieGroupPriorityUniqueMembersKey],
    sheetCuttingMaterial: [...SheetCuttingMaterialUniqueMembersKey],
    sheetBendingMaterial: [...SheetBendingMaterialUniqueMembersKey],
    tubeCuttingProcess: [...TubeCuttingProcessUniqueMembersKey],
    tubeCuttingProcessMapping: [...TubeCuttingProcessMappingUniqueMembersKey],
    tubeCuttingSpeed: [...TubeCuttingSpeedUniqueMembersKey],
    tubeCuttingPierceTime: [...TubeCuttingPierceTimeUniqueMembersKey],
    tubePrice: [...TubePriceUniqueMembersKey],
    tubeStock: [...TubeStockUniqueMembersKey],
    tubeMaterialScrapValue: [...TubeMaterialScrapValueUniqueMembersKey],
};
